"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[60],{

/***/ 35060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductsReviewsNew; }
});

// EXTERNAL MODULE: ../../node_modules/next/node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(92021);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-pswp/dist/index.css
var dist = __webpack_require__(48473);
// EXTERNAL MODULE: ../../node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(28879);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/utc.js
var utc = __webpack_require__(10264);
var utc_default = /*#__PURE__*/__webpack_require__.n(utc);
// EXTERNAL MODULE: ../../node_modules/dayjs/plugin/timezone.js
var timezone = __webpack_require__(67338);
var timezone_default = /*#__PURE__*/__webpack_require__.n(timezone);
// EXTERNAL MODULE: ../../node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(65186);
// EXTERNAL MODULE: ../../node_modules/material-react-toastify/dist/material-react-toastify.cjs.production.min.js
var material_react_toastify_cjs_production_min = __webpack_require__(95546);
// EXTERNAL MODULE: ../../node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(97704);
// EXTERNAL MODULE: ../../node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(951);
// EXTERNAL MODULE: ../../node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(9850);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/utils/addQueryParam.ts
var addQueryParam = __webpack_require__(93452);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 2 modules
var Drawer = __webpack_require__(77533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.esm.js
var vsc_index_esm = __webpack_require__(49385);
// EXTERNAL MODULE: ./node_modules/material-ui-confirm/dist/material-ui-confirm.esm.js
var material_ui_confirm_esm = __webpack_require__(65536);
// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(15567);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/compress/compress.min.js
var compress_min = __webpack_require__(58223);
var compress_min_default = /*#__PURE__*/__webpack_require__.n(compress_min);
;// CONCATENATED MODULE: ./src/components/picker/tools.tsx


// 空函数
var noon = function() {
};
// 获取文件后缀名
var getFileExt = function(fileName) {
    if (typeof fileName === 'string') {
        var ref, ref1;
        return (ref1 = fileName.split('.')) === null || ref1 === void 0 ? void 0 : ref1[((ref = fileName.split('.')) === null || ref === void 0 ? void 0 : ref.length) - 1];
    }
    return 'undefined';
};
// 判断文件是否为图片
var veryImage = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'png',
            'jpg',
            'jpeg',
            'bmp',
            'gif',
            'webp',
            'psd',
            'svg',
            'tiff', 
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
// 判断文件是否为视频
var veryVideo = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'mp4',
            'webm',
            'ogg'
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
// 判断文件是否为音频
var veryAudio = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'mp3',
            'wav',
            'ogg'
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
// 判断文件是否为excel
var veryExcel = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'xls',
            'xlsx'
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
// 判断文件是否为word
var veryWord = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'doc',
            'docx'
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
// 判断文件是否为pdf
var veryPdf = function(fileName) {
    if (typeof fileName === 'string') {
        var ext = getFileExt(fileName);
        return [
            'pdf'
        ].indexOf(ext.toLowerCase()) !== -1;
    }
    return false;
};
var judeFileTypeName = function(type) {
    var ref;
    var fileType = ((ref = type === null || type === void 0 ? void 0 : type.split('/')) === null || ref === void 0 ? void 0 : ref[0]) || '';
    var fileTypeName = '文件';
    switch(fileType){
        case 'image':
            fileTypeName = '图片';
            break;
        case 'audio':
            fileTypeName = '音频';
            break;
        case 'video':
            fileTypeName = '视频';
            break;
        default:
            break;
    }
    return fileTypeName;
};
var judeSiteGif = function(fileName, url) {
    if (typeof fileName === 'string') {
        if (veryImage(fileName)) {
            return url;
        }
        if (veryVideo(fileName)) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "200",
                height: "200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M896 243.882V256H640V0h12.118c12.73 0 24.94 5.058 33.942 14.058l195.882 195.882A48.01 48.01 0 0 1 896 243.882zM576 272V0H176C149.49 0 128 21.49 128 48v928c0 26.51 21.49 48 48 48h672c26.51 0 48-21.49 48-48V320H624c-26.4 0-48-21.6-48-48z m192 288.032v223.926c0 42.89-51.886 63.996-81.942 33.942L576 707.882V784c0 26.51-21.49 48-48 48H304c-26.51 0-48-21.49-48-48V560c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48v76.118l110.058-110.026c30.022-30.02 81.942-8.982 81.942 33.94z",
                    fill: ""
                })
            }));
        }
        if (veryAudio(fileName)) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "200",
                height: "200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M682.666667 85.333333l213.333333 213.333334v597.674666a42.368 42.368 0 0 1-42.368 42.325334H170.368A42.666667 42.666667 0 0 1 128 896.341333V127.658667C128 104.277333 146.986667 85.333333 170.368 85.333333H682.666667z m-213.333334 428.8a106.666667 106.666667 0 1 0 85.333334 104.533334V426.666667h128V341.333333h-213.333334v172.8z"
                })
            }));
        }
        if (veryExcel(fileName)) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "200",
                height: "200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.341 477.839l-61.216 102.307-61.839-102.351a12 12 0 0 0-10.27-5.795h-38.437a12 12 0 0 0-6.406 1.853c-5.604 3.538-7.279 10.949-3.741 16.553l82.333 130.422-83.449 132.787a12 12 0 0 0-1.84 6.385c0 6.627 5.373 12 12 12h34.466a12 12 0 0 0 10.208-5.692l62.707-101.474 62.29 101.445A12 12 0 0 0 582.375 772h37.486a12 12 0 0 0 6.484-1.903c5.577-3.58 7.195-11.004 3.614-16.58l-83.831-130.551 85.296-132.47a12 12 0 0 0 1.91-6.496c0-6.627-5.372-12-12-12h-35.695a12 12 0 0 0-10.297 5.839z"
                })
            }));
        }
        if (veryWord(fileName)) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "200",
                height: "200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.095l52.814 197.012a12 12 0 0 0 11.59 8.893h31.78a12 12 0 0 0 11.587-8.878l74.375-276a12 12 0 0 0 0.413-3.122c0-6.627-5.373-12-12-12h-35.576a12 12 0 0 0-11.695 9.31l-45.79 199.105-49.76-199.321A12 12 0 0 0 528.097 472h-32.192a12 12 0 0 0-11.643 9.094l-49.66 198.927-46.096-198.732a12 12 0 0 0-11.69-9.289h-35.381a12 12 0 0 0-3.115 0.411c-6.4 1.72-10.194 8.303-8.474 14.703l74.173 276A12 12 0 0 0 415.606 772h31.99a12 12 0 0 0 11.59-8.893L512 566.095z"
                })
            }));
        }
        if (veryPdf(fileName)) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "200",
                height: "200",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M491.8 512.2c-10-32-9.8-93.8-4-93.8 16.8 0 15.2 73.8 4 93.8z m-3.4 94.4c-15.4 40.4-34.6 86.6-56.8 125.4 36.6-14 78-34.4 125.8-43.8-25.4-19.2-49.8-46.8-69-81.6zM300.2 856.2c0 1.6 26.4-10.8 69.8-80.4-13.4 12.6-58.2 49-69.8 80.4zM624 320h272v656c0 26.6-21.4 48-48 48H176c-26.6 0-48-21.4-48-48V48C128 21.4 149.4 0 176 0h400v272c0 26.4 21.6 48 48 48z m-16 343.6c-40-24.4-66.6-58-85.4-107.6 9-37 23.2-93.2 12.4-128.4-9.4-58.8-84.8-53-95.6-13.6-10 36.6-0.8 88.2 16.2 154-23.2 55.2-57.4 129.2-81.6 171.6-0.2 0-0.2 0.2-0.4 0.2-54.2 27.8-147.2 89-109 136 11.2 13.8 32 20 43 20 35.8 0 71.4-36 122.2-123.6 51.6-17 108.2-38.2 158-46.4 43.4 23.6 94.2 39 128 39 58.4 0 62.4-64 39.4-86.8-27.8-27.2-108.6-19.4-147.2-14.4zM882 210L686 14c-9-9-21.2-14-34-14h-12v256h256v-12.2c0-12.6-5-24.8-14-33.8z m-148.2 510.6c8.2-5.4-5-23.8-85.6-18 74.2 31.6 85.6 18 85.6 18z"
                })
            }));
        }
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        className: "icon",
        viewBox: "0 0 1024 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: "200",
        height: "200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M896 243.882V256H640V0h12.118c12.73 0 24.94 5.058 33.942 14.058l195.882 195.882A48.01 48.01 0 0 1 896 243.882zM576 272V0H176C149.49 0 128 21.49 128 48v928c0 26.51 21.49 48 48 48h672c26.51 0 48-21.49 48-48V320H624c-26.4 0-48-21.6-48-48z m192 288.032v223.926c0 42.89-51.886 63.996-81.942 33.942L576 707.882V784c0 26.51-21.49 48-48 48H304c-26.51 0-48-21.49-48-48V560c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48v76.118l110.058-110.026c30.022-30.02 81.942-8.982 81.942 33.94z",
            fill: ""
        })
    }));
};

// EXTERNAL MODULE: ./src/components/PhotoSwiper.tsx
var PhotoSwiper = __webpack_require__(25427);
;// CONCATENATED MODULE: ./src/components/picker/image-picker.tsx









function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var prefixCls = 'power-image-picker';
var ImagePicker = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref7) {
    var _value = props.value, value = _value === void 0 ? [] : _value, _onChange = props.onChange, onChange = _onChange === void 0 ? noon : _onChange, _max = props.max, max = _max === void 0 ? 1 : _max, _accept = props.accept, accept = _accept === void 0 ? 'image/jpeg,image/jpg,image/png,' : _accept, multiple = props.multiple, capture = props.capture, _width = props.width, width = _width === void 0 ? '80px' : _width, _height = props.height, height = _height === void 0 ? '80px' : _height, _outputWidth = props.outputWidth, outputWidth = _outputWidth === void 0 ? 1024 : _outputWidth, _outputHeight = props.outputHeight, outputHeight = _outputHeight === void 0 ? 1365 : _outputHeight, _useOriginal = props.useOriginal, useOriginal = _useOriginal === void 0 ? false : _useOriginal, _config = props.config, config = _config === void 0 ? [
        'defaultBackGround'
    ] : _config, children = props.children, _mode = props.mode, mode = _mode === void 0 ? 'cover' : _mode, size = props.size, disabledPreview = props.disabledPreview, disabledSelect = props.disabledSelect, onUpload = props.onUpload, _onFail = props.onFail, onFail = _onFail === void 0 ? noon : _onFail, onFileClick = props.onFileClick, onImageClick = props.onImageClick, _showRemove = props.showRemove, showRemove = _showRemove === void 0 ? true : _showRemove, replace = props.replace, quality = props.quality, className = props.className;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var refInput = ref7 || (0,react.useRef)(null);
    var refFilesList = (0,react.useRef)([]);
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(0), photoIndex = ref2[0], setPhotoIndex = ref2[1];
    var ref3 = (0,react.useState)([]), temporaryArray = ref3[0], setTemporaryArray = ref3[1];
    // 更新
    refFilesList.current = value;
    var urlList = [];
    refFilesList.current.forEach(function(item) {
        if ((item === null || item === void 0 ? void 0 : item.url) && veryImage(item === null || item === void 0 ? void 0 : item.fileName)) {
            urlList.push(item.url);
        }
    });
    // 关闭图片预览
    var onClose = function() {
        return setOpen(function(val) {
            return !val;
        });
    };
    // 图片压缩
    var compress = function(file) {
        return new Promise(function(resolve) {
            // eslint-disable-next-line no-new
            new (compress_min_default())(file, {
                width: outputWidth,
                height: outputHeight,
                useOriginal: useOriginal,
                quality: quality,
                success: function(result) {
                    return resolve(result.blob);
                },
                error: function(err) {
                    console.log('图片压缩失败，将返回原文件：', err.message);
                    resolve(file);
                }
            });
        }).catch(function(e) {
            console.log(e);
        });
    };
    // 图片处理
    var parseFile = _asyncToGenerator(runtime_default().mark(function _callee(file, index, validLength) {
        var data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = file;
                    if (!(quality && veryImage(file === null || file === void 0 ? void 0 : file.name))) {
                        _ctx.next = 7;
                        break;
                    }
                    console.log('compress before', file);
                    _ctx.next = 5;
                    return compress(file);
                case 5:
                    data = _ctx.sent;
                    console.log('compress after', data);
                case 7:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        if (veryImage(file === null || file === void 0 ? void 0 : file.name)) {
                            var reader = new FileReader();
                            reader.readAsDataURL(data);
                            reader.onload = function(e) {
                                var dataURL = e.target.result;
                                if (!dataURL) {
                                    // eslint-disable-next-line prefer-promise-reject-errors
                                    reject("Fail to get the ".concat(index, " image"));
                                    return;
                                }
                                resolve(_objectSpread({
                                }, value[validLength + index], {
                                    file: data,
                                    url: dataURL,
                                    fileName: file === null || file === void 0 ? void 0 : file.name
                                }));
                            };
                        } else {
                            resolve(_objectSpread({
                            }, value[validLength + index], {
                                file: data,
                                url: judeSiteGif(file === null || file === void 0 ? void 0 : file.name, ''),
                                fileName: file === null || file === void 0 ? void 0 : file.name
                            }));
                        }
                    }));
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    // 图片改变
    // eslint-disable-next-line consistent-return
    var onChangeHandle = function(e) {
        var fileSelectorEl = e.target;
        var files = fileSelectorEl.files;
        if (!files || !files.length) {
            // eslint-disable-next-line no-return-assign
            return fileSelectorEl.value = '';
        }
        console.log('files', files);
        var restNum = max - (replace ? 0 : value.length);
        if (files.length > (replace ? max : restNum)) {
            material_react_toastify_cjs_production_min.toast.dark("Select up to ".concat(max, " photos"));
        }
        var restFileList = Array.from(files).slice(0, restNum);
        var temporaryCopyArray = restFileList.map(function() {
            return {
                url: judeSiteGif(),
                loading: true
            };
        });
        // @ts-ignore
        setTemporaryArray(temporaryCopyArray);
        var imageParsePromiseList = [];
        // eslint-disable-next-line no-plusplus
        for(var i1 = 0; i1 < restFileList.length; i1++){
            imageParsePromiseList.push(parseFile(restFileList[i1], i1, value.length));
        }
        refFilesList.current = refFilesList.current.filter(function(item) {
            return item.url || item.errorTip;
        }) // 过滤有效值
        ;
        var index = replace ? 0 : refFilesList.current.length;
        Promise.all(imageParsePromiseList).then(function(imageItems) {
            if (typeof onUpload === 'function') {
                // eslint-disable-next-line no-param-reassign,no-return-assign
                imageItems.forEach(function(item) {
                    return item.loading = true;
                });
            }
            var filterList = imageItems.filter(function(item) {
                if (size) {
                    // 限制文件大小
                    var sizeNum = 10;
                    if (typeof size === 'number') {
                        // 统一限制文件大小
                        sizeNum = size;
                    } else {
                        var ref, ref4, ref5;
                        // 自定义单独文件格式大小
                        sizeNum = size === null || size === void 0 ? void 0 : size.default;
                        var fileType = (ref5 = item === null || item === void 0 ? void 0 : (ref = item.file) === null || ref === void 0 ? void 0 : (ref4 = ref.type) === null || ref4 === void 0 ? void 0 : ref4.split('/')) === null || ref5 === void 0 ? void 0 : ref5[0];
                        if (size[fileType]) {
                            sizeNum = size[fileType];
                        }
                    }
                    if (item.file.size > sizeNum * 1024 * 1024) {
                        var ref6;
                        material_react_toastify_cjs_production_min.toast.dark("".concat(judeFileTypeName((ref6 = item.file) === null || ref6 === void 0 ? void 0 : ref6.type), " size must not exceed ").concat(sizeNum, "M"));
                        return false;
                    }
                }
                return true;
            });
            if (replace) {
                refFilesList.current = _toConsumableArray(filterList);
            } else {
                refFilesList.current = refFilesList.current.concat(filterList);
            }
            onChange(refFilesList.current);
            setTemporaryArray([]);
            if (typeof onUpload === 'function') {
                var _loop = function(i) {
                    var item = refFilesList.current[i];
                    if (i >= index) {
                        onUpload(item).then(function(res) {
                            refFilesList.current[i] = _objectSpread({
                            }, refFilesList.current[i], res, {
                                loading: false
                            });
                            refFilesList.current = _toConsumableArray(refFilesList.current);
                            setTimeout(function() {
                                return onChange(refFilesList.current);
                            }, 10);
                        }).catch(function(err) {
                            refFilesList.current[i] = _objectSpread({
                            }, refFilesList.current[i], {
                                url: '',
                                loading: false,
                                errorTip: err || '上传失败'
                            });
                            refFilesList.current = _toConsumableArray(refFilesList.current);
                            setTimeout(function() {
                                return onChange(refFilesList.current);
                            }, 10);
                        });
                    }
                };
                // eslint-disable-next-line no-plusplus
                for(var i = 0; i < refFilesList.current.length; i++)_loop(i);
            }
            fileSelectorEl.value = '';
        }).catch(function(error) {
            onFail(error);
            fileSelectorEl.value = '';
            setTemporaryArray([]);
        });
    };
    // 选择图片
    var inputClick = function() {
        if (disabledSelect) return;
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        refInput && refInput.current && refInput.current.click();
    };
    // 删除图片
    // eslint-disable-next-line consistent-return
    var onRemove = function(index) {
        var ableDelete = true;
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < refFilesList.current.length; i++){
            var loading = refFilesList.current[i].loading;
            if (loading) {
                ableDelete = false;
                break;
            }
        }
        if (!ableDelete) {
            return material_react_toastify_cjs_production_min.toast.dark('文件上传中，请稍后操作');
        }
        refFilesList.current.splice(index, 1);
        refFilesList.current = _toConsumableArray(refFilesList.current);
        onChange(refFilesList.current);
    };
    // 预览图片
    var onPreview = _asyncToGenerator(runtime_default().mark(function _callee(currentIndex, index) {
        var ref, ref8;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!disabledPreview) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    if (!(veryImage((ref = refFilesList.current[index]) === null || ref === void 0 ? void 0 : ref.fileName) && typeof onImageClick === 'function')) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", onImageClick(index, refFilesList.current[index]));
                case 5:
                    if (!(!veryImage((ref8 = refFilesList.current[index]) === null || ref8 === void 0 ? void 0 : ref8.fileName) && typeof onFileClick === 'function')) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", onFileClick(index, refFilesList.current[index]));
                case 7:
                    setPhotoIndex(currentIndex);
                    onClose();
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " ").concat(prefixCls, "-root"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "".concat(prefixCls, "-hidden"),
                ref: refInput,
                type: "file",
                accept: accept,
                multiple: multiple,
                capture: capture,
                onChange: onChangeHandle
            }),
            value && value.length > 0 && // eslint-disable-next-line array-callback-return,consistent-return
            value.map(function(item, index) {
                var url = item.url, loading = item.loading, name = item.name, errorTip = item.errorTip;
                if (url || errorTip || loading) {
                    var currentArr = value.slice(0, index + 1);
                    var errorNum = 0;
                    // eslint-disable-next-line no-plusplus
                    for(var i = 0; i < currentArr.length; i++){
                        var _i = currentArr[i], ErrorTip = _i.errorTip, fileNameItem = _i.fileName;
                        if (ErrorTip || !veryImage(fileNameItem)) {
                            // eslint-disable-next-line no-plusplus
                            errorNum++;
                        }
                    }
                    var currentIndex = index - errorNum;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(prefixCls, "-parent"),
                        style: {
                            paddingTop: "".concat(// @ts-ignore
                            (width.replace(/[^0-9]/gi, '') / // @ts-ignore
                            height.replace(/[^0-9]/gi, '')) * 100, "%")
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default().apply(void 0, [
                                    "".concat(prefixCls, "-img-box")
                                ].concat(_toConsumableArray(config.map(function(todo) {
                                    return [
                                        "".concat(prefixCls, "-").concat(todo)
                                    ];
                                })))),
                                children: [
                                    url && // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "",
                                        className: "".concat(prefixCls, "-img"),
                                        src: url,
                                        style: {
                                            objectFit: mode
                                        },
                                        onClick: function() {
                                            return onPreview(currentIndex, index);
                                        }
                                    }),
                                    errorTip && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(prefixCls, "-error-tip"),
                                        children: errorTip
                                    }),
                                    showRemove && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "".concat(prefixCls, "-icon-remove"),
                                        onClick: function() {
                                            return onRemove(index);
                                        }
                                    }),
                                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(prefixCls, "-loading-box"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "".concat(prefixCls, "-icon-loading")
                                        })
                                    })
                                ]
                            }),
                            name && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(prefixCls, "-name"),
                                children: name
                            })
                        ]
                    }, index));
                }
            }),
            temporaryArray && temporaryArray.length > 0 && temporaryArray.map(function(item, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                    className: "".concat(prefixCls, "-parent"),
                    style: {
                        paddingTop: "".concat(// @ts-ignore
                        (width.replace(/[^0-9]/gi, '') / // @ts-ignore
                        height.replace(/[^0-9]/gi, '')) * 100, "%")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default().apply(void 0, [
                            "".concat(prefixCls, "-img-box")
                        ].concat(_toConsumableArray(config.map(function(todo) {
                            return [
                                "".concat(prefixCls, "-").concat(todo)
                            ];
                        })))),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "",
                                className: "".concat(prefixCls, "-img"),
                                src: item.url,
                                style: {
                                    objectFit: mode
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(prefixCls, "-loading-box"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "".concat(prefixCls, "-icon-loading")
                                })
                            })
                        ]
                    })
                }, index);
            }),
            value.length + (temporaryArray === null || temporaryArray === void 0 ? void 0 : temporaryArray.length) < max && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(prefixCls, "-parent-select"),
                style: {
                    paddingTop: "".concat(// @ts-ignore
                    (width.replace(/[^0-9]/gi, '') / // @ts-ignore
                    height.replace(/[^0-9]/gi, '')) * 100, "%")
                },
                onClick: inputClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat(prefixCls, "-img-box"),
                    children: children || /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("".concat(prefixCls, "-children-ele"), _toConsumableArray(config.map(function(todo) {
                            return [
                                "".concat(prefixCls, "-").concat(todo)
                            ];
                        })))
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoSwiper/* default */.Z, {
                images: urlList,
                open: isOpen,
                onOpenChange: onClose,
                initialSlide: photoIndex
            })
        ]
    }));
});
/* harmony default export */ var image_picker = (ImagePicker);

// EXTERNAL MODULE: ./src/api/service/user.ts
var user = __webpack_require__(48901);
;// CONCATENATED MODULE: ./src/components/products/reviews/RadioButton.tsx


/**
 * min Ranting 从下标1开始
 */ // eslint-disable-next-line import/prefer-default-export
var RadioButton = function(param) {
    var _arr = param.arr, arr = _arr === void 0 ? [] : _arr, _labelKey = param.labelKey, labelKey = _labelKey === void 0 ? 'label' : _labelKey, _valueKey = param.valueKey, valueKey = _valueKey === void 0 ? 'value' : _valueKey, _value = param.value, value = _value === void 0 ? 0 : _value, disabled = param.disabled, _className = param.className, className = _className === void 0 ? '' : _className, _StarClassName = param.StarClassName, StarClassName = _StarClassName === void 0 ? '' : _StarClassName, onSelect = param.onSelect;
    var onHandleSelect = function onHandleSelect(index) {
        if (disabled) {
            return;
        }
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(index);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " cursor-none"),
        children: arr.map(function(i, idx) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: "inline-block border rounded-full border-gray-100 bg-tag-grayf5 text-xs cursor-pointer ".concat(i[valueKey] === value ? 'bg-tag-yellow-light border-tag-yellow-light text-white' : 'text-gray-400', " ").concat(StarClassName),
                style: {
                    margin: '2px 3.5px'
                },
                onClick: function() {
                    return onHandleSelect(idx);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center items-center px-1 h-5.5",
                    style: {
                        transform: 'scale(0.8333)',
                        minWidth: '47px'
                    },
                    children: i[labelKey]
                })
            }, "radio-item".concat(idx));
        })
    }));
};

// EXTERNAL MODULE: ./src/components/products/reviews/Rating.tsx + 1 modules
var Rating = __webpack_require__(23035);
// EXTERNAL MODULE: ./src/utils/scroll-handler.ts
var scroll_handler = __webpack_require__(73865);
;// CONCATENATED MODULE: ./src/components/products/reviews/utils.ts



function utils_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function utils_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function utils_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function utils_toConsumableArray(arr) {
    return utils_arrayWithoutHoles(arr) || utils_iterableToArray(arr) || utils_nonIterableSpread();
}
function scrollToReviews() {
    var // @ts-ignore
    ref;
    (0,scroll_handler/* scrollAnimation */.QB)(((ref = document.querySelector('.reviews-wrapper')) === null || ref === void 0 ? void 0 : ref.offsetTop) - 88 || 0);
}
// 解析被加密的字符串
var parseFn = function(str) {
    try {
        var res = JSON.parse(decodeURIComponent(window.atob(str)));
        if (typeof res === 'object' && Array.isArray(res)) {
            return res;
        }
        return [];
    } catch (e) {
        return [];
    }
};
// 获取储存到LocalStorage的评论
var getLocalReviews = function() {
    var localReview = window.localStorage.getItem('posted_rvs');
    // console.log('reviewCache', parseFn(localReview))
    return localReview && localReview !== 'undefined' ? parseFn(localReview) : [];
};
//  获取两小时内发布的评论：
// （如果已登录，还要匹配登录账号对应的已发布评论）
// （如果传入productHandle，还要匹配handle对应的已发布评论）
var get2HoursLocalReviews = function(productHandle) {
    return getLocalReviews().filter(function(r) {
        return dayjs_min_default()(r.createdAt).add(2, 'hour').isAfter(dayjs_min_default()()) && ((0,user/* getToken */.LP)() ? r.reviewerEmail === (0,user/* getEmail */.OD)() : true) && (productHandle ? r.productHandle === productHandle : true);
    });
};
// 储存评论到LocalStorage，顺便清除已过期的评论
function saveReview(review) {
    // eslint-disable-next-line no-param-reassign
    review = Array.isArray(review) ? review : [
        review
    ];
    // console.log('review ', review)
    var reviewCache = get2HoursLocalReviews();
    // console.log('reviewCache ', reviewCache)
    reviewCache = utils_toConsumableArray(review).concat(utils_toConsumableArray(reviewCache));
    window.localStorage.setItem('posted_rvs', window.btoa(encodeURIComponent(JSON.stringify(reviewCache))));
}

// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(21960);
;// CONCATENATED MODULE: ./src/components/products/reviews/config.ts

var BASE_URL = config/* default.api_url */.Z.api_url;
// '//localhost:3000/dev'
var SORT_ARR = [
    {
        label: 'Pictures First',
        value: 'sortKey=MEDIA_FIRST'
    },
    {
        label: 'Most Recent',
        value: 'sortKey=CREATED'
    },
    {
        label: 'Highest Rating',
        value: 'sortKey=RATING'
    },
    {
        label: 'Lowest Rating',
        value: 'sortKey=RATING&reverse=true'
    }, 
];
var STRETCH_ARR = [
    {
        label: 'High Stretch',
        value: 0
    },
    {
        label: 'Slight Stretch',
        value: 1
    },
    {
        label: 'No Stretch',
        value: 2
    }, 
];
var FITTING_ARR = [
    {
        label: 'True to Size',
        value: 0
    },
    {
        label: 'Small',
        value: 1
    },
    {
        label: 'Large',
        value: 2
    }, 
];

// EXTERNAL MODULE: ./src/theme/theme.ts
var theme = __webpack_require__(10929);
;// CONCATENATED MODULE: ./src/hooks/useWindowSize.ts


// Usage
// function App() {
//   const size: Size = useWindowSize()
//   return (
//     <div>
//       { size.width } px / { size.height }px
//     </div>
//   )
// }
// Hook
// eslint-disable-next-line import/prefer-default-export
function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    var ref = (0,react.useState)({
        width: undefined,
        height: undefined,
        upXs: undefined,
        upSm: undefined,
        upMd: undefined,
        upLg: undefined,
        upXl: undefined,
        up2Xl: undefined
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react.useEffect)(function() {
        var handleResize = // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
                upXs: window.innerWidth > theme/* default.breakpoints.values.xs */.Z.breakpoints.values.xs,
                upSm: window.innerWidth > theme/* default.breakpoints.values.sm */.Z.breakpoints.values.sm,
                upMd: window.innerWidth > theme/* default.breakpoints.values.md */.Z.breakpoints.values.md,
                upLg: window.innerWidth > theme/* default.breakpoints.values.lg */.Z.breakpoints.values.lg,
                upXl: window.innerWidth > theme/* default.breakpoints.values.xl */.Z.breakpoints.values.xl,
                up2Xl: window.innerWidth > theme/* default.breakpoints.values.2xl */.Z.breakpoints.values["2xl"]
            });
        };
        // Add event listener
        window.addEventListener('resize', handleResize);
        // Call handler right away so state gets updated with initial window size
        handleResize();
        // Remove event listener on cleanup
        return function() {
            return window.removeEventListener('resize', handleResize);
        };
    }, []) // Empty array ensures that effect is only run on mount
    ;
    return windowSize;
}

// EXTERNAL MODULE: ./src/theme/button.ts
var theme_button = __webpack_require__(98078);
;// CONCATENATED MODULE: ./src/hooks/useRecaptchaHook.ts


function useRecaptchaHook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useRecaptchaHook_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useRecaptchaHook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useRecaptchaHook_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// eslint-disable-next-line import/prefer-default-export
var useRecaptchaHook = function(recaptchaSiteKey, param, param1) {
    var recaptchaAction = param === void 0 ? 'homepage' : param, initOnload = param1 === void 0 ? false : param1;
    var ref = (0,react.useState)(''), recaptchaToken = ref[0], setRecaptchaToken = ref[1];
    (0,react.useEffect)(function() {
        if (recaptchaToken || !true || !initOnload || typeof window.grecaptcha === 'undefined') {
            return;
        }
        var grecaptcha = window.grecaptcha;
        grecaptcha.ready(useRecaptchaHook_asyncToGenerator(runtime_default().mark(function _callee() {
            var action, token;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        action = {
                            action: recaptchaAction
                        };
                        console.log('recaptchaAction: ', action);
                        _ctx.next = 4;
                        return grecaptcha.execute(recaptchaSiteKey, action);
                    case 4:
                        token = _ctx.sent;
                        setRecaptchaToken(token);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })));
    }, [
        recaptchaAction,
        recaptchaSiteKey,
        recaptchaToken
    ]);
    var executeReCaptcha = useRecaptchaHook_asyncToGenerator(runtime_default().mark(function _callee(action) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!( false || typeof window.grecaptcha === 'undefined')) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", '');
                case 2:
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        window.grecaptcha.ready(function() {
                            console.log('recaptchaAction: ', action);
                            window.grecaptcha.execute(recaptchaSiteKey, {
                                action: action
                            })// @ts-ignore
                            .then(function(token) {
                                return resolve(token);
                            });
                        });
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return {
        executeReCaptcha: executeReCaptcha,
        recaptchaToken: recaptchaToken
    };
};

;// CONCATENATED MODULE: ./src/components/products/reviews/FormDrawer.tsx















// import { scrollToReviews, saveReview } from './utils'




function FormDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function FormDrawer_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                FormDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                FormDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function FormDrawer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FormDrawer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FormDrawer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var submitTimer = null;
var outerToast = function(msg) {
    window.parent.postMessage({
        toast: msg
    }, '*');
};
var getName = function() {
    return  true ? window.localStorage.getItem('_nick_name') || '' : 0;
};
var getReviewEmail = function() {
    return  true ? window.localStorage.getItem('_review_email') || '' : 0;
};
// const getReviewFigure = () => {
//   typeof window !== 'undefined'
//   ? window.localStorage.getItem('_review_figure') || ''
//   : ''
// }
// eslint-disable-next-line import/prefer-default-export
var FormDrawer = function(param) {
    var drawerOpen = param.drawerOpen, onClose = param.onClose, figure = param.figure, productId = param.productId, pTitle = param.pTitle, pCover = param.pCover, pHandle = param.pHandle, reviewReportData = param.reviewReportData, platform = param.platform, isEmail = param.isEmail, _isExtension = param.isExtension, isExtension = _isExtension === void 0 ? false : _isExtension, loginEmail = param.loginEmail;
    var getUserFigure = function getUserFigure(email) {
        fetch("".concat(BASE_URL, "/review/find_figure?email=").concat(email)).then(function(res) {
            return res.json();
        }).then(function(data) {
            var ref;
            console.log(data.body);
            if (data === null || data === void 0 ? void 0 : (ref = data.body) === null || ref === void 0 ? void 0 : ref.value) {
                var ref13;
                setTimeout(function() {
                    return console.log(data.body, form);
                }, 0);
                var fig = data === null || data === void 0 ? void 0 : (ref13 = data.body) === null || ref13 === void 0 ? void 0 : ref13.value;
                setForm(FormDrawer_objectSpread({
                }, form, {
                    height: fig.heights,
                    weight: fig.weights,
                    bust: fig.busts,
                    waist: fig.waists,
                    hips: fig.hips
                }));
            }
        }).catch(function(err) {
            // eslint-disable-next-line no-console
            console.log(err);
            toast.dark('Failed to fetch figure data');
        });
    };
    var computeCount = // 计算单词或者汉字字符数
    function computeCount(words) {
        var sLen = 0;
        var str = words;
        try {
            // 先将回车换行符做特殊处理
            // eslint-disable-next-line no-irregular-whitespace
            str = str.replace(/(\r\n+|\s+|　+)/g, '龘');
            // 处理英文字符数字，连续字母、数字、英文符号视为一个单词
            // eslint-disable-next-line no-control-regex
            str = str.replace(/[\x00-\xff]/g, 'm');
            // 合并字符m，连续字母、数字、英文符号视为一个单词
            str = str.replace(/m+/g, '*');
            // 去掉回车换行符
            str = str.replace(/龘+/g, '');
            // 返回字数
            sLen = str.length;
        } catch (e) {
            console.log(e);
        }
        return sLen;
    };
    var checkEmail = function checkEmail(str) {
        return /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(str);
    };
    var checkValue = function checkValue(e) {
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var _target = e.target, name = _target.name, value = _target.value;
        switch(name){
            case 'name':
            case 'body':
                setShowError(function() {
                    return FormDrawer_objectSpread({
                    }, showError, FormDrawer_defineProperty({
                    }, name, !value));
                });
                break;
            case 'email':
                setShowError(function() {
                    return FormDrawer_objectSpread({
                    }, showError, FormDrawer_defineProperty({
                    }, name, !checkEmail(value)));
                });
                break;
            default:
                break;
        }
    };
    var setFormValues = function setFormValues(e, toNumber) {
        e.preventDefault();
        console.log(+e.target.value);
        setForm(FormDrawer_objectSpread({
        }, form, FormDrawer_defineProperty({
        }, e.target.name, toNumber ? +e.target.value : e.target.value.trim())));
        setShowError(FormDrawer_objectSpread({
        }, showError, FormDrawer_defineProperty({
        }, e.target.name, false)));
    // if (e.target.value) checkValue(e)
    };
    var clearForm = function clearForm() {
        setOpenMoreRating(false);
        setForm(FormDrawer_objectSpread({
        }, initForm, {
            name: getName() || '',
            email: getInputEmail()
        }));
        setValue([]);
        setStep(0);
    };
    var nextChecked = function nextChecked() {
        var averageRating = form.averageRating, costEffective = form.costEffective, comfort = form.comfort, stretch = form.stretch, fitting = form.fitting, body = form.body;
        var showSomeError = function(err) {
            var allFun = {
                averageRating: averageRating < 1,
                costEffective: !costEffective,
                comfort: !comfort,
                stretch: stretch < 0,
                fitting: fitting < 0,
                body: !body
            };
            setShowError(FormDrawer_objectSpread({
            }, showError, // @ts-ignore
            FormDrawer_defineProperty({
            }, err, allFun[err])));
        };
        if (!averageRating) {
            var ref;
            averageRatingRef === null || averageRatingRef === void 0 ? void 0 : (ref = averageRatingRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            toast.dark('Please rate overall score');
            showSomeError('averageRating');
            return 1;
        }
        if (!costEffective) {
            var ref15;
            costEffectiveRef === null || costEffectiveRef === void 0 ? void 0 : (ref15 = costEffectiveRef.current) === null || ref15 === void 0 ? void 0 : ref15.focus();
            toast.dark('Please rate the level of value for cost');
            showSomeError('costEffective');
            return 2;
        }
        if (!comfort) {
            var ref16;
            comfortRef === null || comfortRef === void 0 ? void 0 : (ref16 = comfortRef.current) === null || ref16 === void 0 ? void 0 : ref16.focus();
            toast.dark('Please rate level of comfort');
            showSomeError('comfort');
            return 3;
        }
        if (stretch < 0) {
            var ref17;
            stretchRef === null || stretchRef === void 0 ? void 0 : (ref17 = stretchRef.current) === null || ref17 === void 0 ? void 0 : ref17.focus();
            toast.dark('Please rate elasticity');
            showSomeError('stretch');
            return 4;
        }
        if (fitting < 0) {
            var ref18;
            fittingRef === null || fittingRef === void 0 ? void 0 : (ref18 = fittingRef.current) === null || ref18 === void 0 ? void 0 : ref18.focus();
            toast.dark('Please rate fit');
            showSomeError('fitting');
            return 5;
        }
        if (!body) {
            var ref19;
            bodyRef === null || bodyRef === void 0 ? void 0 : (ref19 = bodyRef.current) === null || ref19 === void 0 ? void 0 : ref19.focus();
            setShowError(function() {
                return FormDrawer_objectSpread({
                }, showError, {
                    body: !body
                });
            });
            toast.dark('Please write down your review');
            return 6;
        }
        if (value1.length && value1.find(function(i) {
            return !i.remoteUrl;
        })) {
            toast.dark('Photos upload failed. Please try again');
            return 10;
        }
        return 11;
    };
    var submitChecked = function submitChecked() {
        var name = form.name, email = form.email;
        if (!name) {
            var ref;
            nameRef === null || nameRef === void 0 ? void 0 : (ref = nameRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            toast.dark('Please enter your name');
            return 7;
        }
        window.localStorage.setItem('_nick_name', name);
        if (!email) {
            var ref20;
            emailRef === null || emailRef === void 0 ? void 0 : (ref20 = emailRef.current) === null || ref20 === void 0 ? void 0 : ref20.focus();
            toast.dark('Please enter your email');
            return 8;
        }
        window.localStorage.setItem('_review_email', email);
        if (!checkEmail(email)) {
            var ref21;
            emailRef === null || emailRef === void 0 ? void 0 : (ref21 = emailRef.current) === null || ref21 === void 0 ? void 0 : ref21.focus();
            toast.dark('Please enter a valid email address');
            return 9;
        }
        return 11;
    };
    var findFigure = function findFigure() {
        if (loginEmail) {
            getUserFigure(loginEmail);
        }
        var uemail = (0,user/* getEmail */.OD)();
        if (uemail) {
            getUserFigure(uemail);
        } else {
            getUserFigureLocal();
        }
    };
    var marsWriteReviewBodySizesShow = // 上报
    function marsWriteReviewBodySizesShow() {
        var ref;
        console.log('WriteReviewBodySizesShow', reviewReportData);
        window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('WriteReviewBodySizesShow', FormDrawer_objectSpread({
        }, reviewReportData));
    };
    var ref14, ref1, ref2, ref3, ref4;
    var executeReCaptcha = useRecaptchaHook("6LegPPUdAAAAAFoeM76CJQe78sOmitmcmc30kB70" || 0).executeReCaptcha;
    // const token = useRecaptchaHook(process.env.NEXT_PUBLIC_SITE_KEY || '')
    var toast = isExtension ? {
        dark: outerToast
    } : material_react_toastify_cjs_production_min.toast;
    var confirm = (0,material_ui_confirm_esm/* useConfirm */.N)();
    var getInputEmail = function() {
        if (loginEmail) {
            return loginEmail;
        }
        return (0,user/* getEmail */.OD)() || getReviewEmail() || '';
    };
    var initForm = {
        averageRating: 0,
        costEffective: 0,
        comfort: 0,
        stretch: -1,
        fitting: -1,
        body: '',
        height: -1,
        weight: -1,
        bust: -1,
        waist: -1,
        hips: -1,
        name: getName() || '',
        email: getInputEmail()
    };
    var averageRatingRef = (0,react.useRef)();
    var costEffectiveRef = (0,react.useRef)();
    var comfortRef = (0,react.useRef)();
    var stretchRef = (0,react.useRef)();
    var fittingRef = (0,react.useRef)();
    var bodyRef = (0,react.useRef)();
    var nameRef = (0,react.useRef)();
    var emailRef = (0,react.useRef)();
    var ref5 = (0,react.useState)(0), step = ref5[0], setStep = ref5[1];
    var ref6 = (0,react.useState)(false), openMoreRating = ref6[0], setOpenMoreRating = ref6[1];
    var ref7 = (0,react.useState)(initForm), form = ref7[0], setForm = ref7[1];
    var ref8 = (0,react.useState)(false), needConfirm = ref8[0], setNeedConfirm = ref8[1];
    var ref9 = (0,react.useState)({
        averageRating: false,
        costEffective: false,
        comfort: false,
        stretch: false,
        fitting: false,
        body: false,
        height: false,
        weight: false,
        bust: false,
        waist: false,
        hips: false,
        name: false,
        email: false
    }), showError = ref9[0], setShowError = ref9[1];
    var ref10 = (0,react.useState)(false), loading = ref10[0], setLoading = ref10[1];
    var ref11 = (0,react.useState)(0), bodyWords = ref11[0], setBodyWords = ref11[1];
    var ref12 = (0,react.useState)([]), value1 = ref12[0], setValue = ref12[1];
    var upSm = useWindowSize().upSm;
    var getUserFigureLocal = function() {
        if (true) {
            var localFigure = window.localStorage.getItem('_review_figure');
            if (localFigure) {
                setForm(FormDrawer_objectSpread({
                }, form, JSON.parse(localFigure)));
            }
        }
    };
    var onChange = function(arr) {
        setValue(arr);
    };
    function upload(base64) {
        return _upload.apply(this, arguments);
    }
    function _upload() {
        _upload = // eslint-disable-next-line consistent-return
        FormDrawer_asyncToGenerator(runtime_default().mark(function _callee(base64) {
            var res, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return fetch("".concat(BASE_URL, "/uploadImg"), {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify({
                                files: base64
                            })
                        });
                    case 3:
                        res = _ctx.sent;
                        if (!(res.status === 200 && res.ok)) {
                            _ctx.next = 9;
                            break;
                        }
                        _ctx.next = 7;
                        return res.json();
                    case 7:
                        data = _ctx.sent;
                        return _ctx.abrupt("return", data.body.url);
                    case 9:
                        return _ctx.abrupt("return", null);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                        toast.dark('Oops, upload failed. Please check your network and try again.');
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return _upload.apply(this, arguments);
    }
    var onUpload = FormDrawer_asyncToGenerator(runtime_default().mark(function _callee(item) {
        var url;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return upload(item.url);
                case 2:
                    url = _ctx.sent;
                    console.log(url);
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        var rate = Math.random();
                        // @ts-ignore
                        if (url) {
                            return resolve({
                                fsid: rate.toString().slice(-6),
                                remoteUrl: url
                            });
                        }
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject('Upload fail');
                    // eslint-disable-next-line prefer-promise-reject-errors
                    // eslint-disable-next-line consistent-return
                    // setTimeout(() => {
                    //   console.log(item)
                    //   if (rate > 0.1) {
                    //     // 成功
                    //     return resolve({ fssid: rate.toString().slice(-6) })
                    //   }
                    //   // eslint-disable-next-line prefer-promise-reject-errors
                    //   reject('Upload fail')
                    // }, 1000)
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    var handleClose = function() {
        clearForm();
        onClose();
    };
    var onConfirmClose = function() {
        confirm({
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center font-semibold text-lg leading-1.2 px-2",
                children: "Are you sure you want to quit?"
            }),
            description: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center font-medium text-gray-400 leading-tight",
                children: "Your review content will not be saved."
            }),
            dialogProps: {
                sx: {
                    '.MuiPaper-root': {
                        maxWidth: '320px',
                        borderRadius: '0!important',
                        px: '16px!important',
                        py: '16px!important'
                    },
                    '.MuiDialogActions-root': {
                        flexFlow: 'row-reverse wrap',
                        pt: '4px!important'
                    }
                }
            },
            cancellationText: 'Stay',
            cancellationButtonProps: {
                sx: FormDrawer_objectSpread({
                }, theme_button/* styleBtnBlack */.J, {
                    mt: 0,
                    width: '100%',
                    order: 1
                })
            },
            confirmationText: 'Quit',
            confirmationButtonProps: {
                sx: FormDrawer_objectSpread({
                }, theme_button/* styleBtnWhite */.h, {
                    mt: 2,
                    ml: '0!important',
                    width: '100%',
                    order: 2
                })
            }
        }).then(function() {
            handleClose();
        }).catch(function() {
        });
    };
    var saveReviewFigure = function(data) {
        if (true) {
            window.localStorage.setItem('_review_figure', JSON.stringify({
                height: data.height,
                weight: data.weight,
                bust: data.bust,
                waist: data.waist,
                hips: data.hips
            }));
        }
    };
    function handleSubmitReviews() {
        return _handleSubmitReviews.apply(this, arguments);
    }
    function _handleSubmitReviews() {
        _handleSubmitReviews = // eslint-disable-next-line @typescript-eslint/no-unused-vars
        FormDrawer_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref22, ref23, ref24, nextReviews, ref25, nextResult, submitResult, submitReviews, token, postData, ref26, res, data, // 评论后自动储存评论，两小时内回显
            // saveReview(data.body.result)
            ref27, ref28, ref29;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        nextReviews = {
                            overall_rating: form.averageRating,
                            value_for_cost: form.costEffective,
                            comfort_level: form.comfort,
                            elasticity: ((ref = STRETCH_ARR.find(function(item) {
                                return item.value === form.stretch;
                            })) === null || ref === void 0 ? void 0 : ref.label) || 'NULL',
                            fit: ((ref22 = FITTING_ARR.find(function(item) {
                                return item.value === form.fitting;
                            })) === null || ref22 === void 0 ? void 0 : ref22.label) || 'NULL',
                            review_words_number: ((ref23 = form.body) === null || ref23 === void 0 ? void 0 : ref23.length) || 0,
                            photo_number: value1.filter(function(i) {
                                return i.remoteUrl;
                            }).length,
                            name_content: form.name || 'NULL',
                            email_content: form.email || 'NULL'
                        };
                        if (!(step === 0)) {
                            _ctx.next = 13;
                            break;
                        }
                        ;
                        nextResult = nextChecked();
                        console.log('NextReviewButtonClick', FormDrawer_objectSpread({
                        }, reviewReportData, nextReviews, {
                            review_next_result: nextResult
                        }));
                        window === null || window === void 0 ? void 0 : (ref25 = window.sensors) === null || ref25 === void 0 ? void 0 : ref25.track('NextReviewButtonClick', FormDrawer_objectSpread({
                        }, reviewReportData, nextReviews, {
                            review_next_result: nextResult
                        }));
                        if (!(nextResult !== 11)) {
                            _ctx.next = 11;
                            break;
                        }
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 11:
                        // if (step === 0) {
                        setStep(1);
                        return _ctx.abrupt("return");
                    case 13:
                        setLoading(true);
                        submitResult = submitChecked();
                        submitReviews = {
                            height_content: figure.heights[form.height] || 'NULL',
                            weight_content: figure.weights[form.weight] || 'NULL',
                            bust_content: figure.busts[form.bust] || 'NULL',
                            waist_content: figure.waists[form.waist] || 'NULL',
                            hips_content: figure.hips[form.hips] || 'NULL',
                            review_submit_result: submitResult,
                            name_content: form.name || 'NULL',
                            email_content: form.email || 'NULL'
                        };
                        window === null || window === void 0 ? void 0 : (ref24 = window.sensors) === null || ref24 === void 0 ? void 0 : ref24.track('SubmitReviewButtonClick', FormDrawer_objectSpread({
                        }, reviewReportData, submitReviews, {
                            review_submit_result: submitResult
                        }));
                        console.log('SubmitReviewButtonClick', FormDrawer_objectSpread({
                        }, reviewReportData, submitReviews, {
                            review_submit_result: submitResult
                        }));
                        if (!(submitResult !== 11)) {
                            _ctx.next = 21;
                            break;
                        }
                        setLoading(false);
                        return _ctx.abrupt("return");
                    case 21:
                        _ctx.next = 23;
                        return executeReCaptcha('submit');
                    case 23:
                        token = _ctx.sent;
                        postData = {
                            recaptcha_token: token,
                            title: '',
                            body: form.body,
                            rating: form.averageRating,
                            name: form.name,
                            email: form.email,
                            product_id: productId,
                            product_handle: pHandle,
                            product_title: pTitle,
                            product_imgurl: pCover,
                            picture_urls: value1.filter(function(i) {
                                return i.remoteUrl;
                            }).map(function(i) {
                                return i.remoteUrl;
                            }).join(','),
                            videos_urls: '',
                            extend: {
                                cost_effective: form.costEffective,
                                comfort: form.comfort,
                                stretch: form.stretch,
                                fitting: form.fitting
                            },
                            figure: {
                                heights: form.height,
                                weights: form.weight,
                                busts: form.bust,
                                waists: form.waist,
                                hips: form.hips
                            },
                            ytkey: '',
                            uemail: loginEmail || (0,user/* getEmail */.OD)(),
                            // eslint-disable-next-line no-nested-ternary
                            source: platform ? platform === 'pc' ? 1 : 0 : upSm ? 1 : 0,
                            isEmail: isEmail
                        };
                        submitTimer = setTimeout(function() {
                            toast.dark('Submit timeout');
                            setLoading(false);
                        }, 30000);
                        if (typeof navigator !== 'undefined' && !navigator.onLine) {
                            ;
                            toast.dark('Network unavailable. Please check your network and try again.');
                            clearTimeout(submitTimer);
                            setLoading(false);
                            window === null || window === void 0 ? void 0 : (ref26 = window.sensors) === null || ref26 === void 0 ? void 0 : ref26.track('ReviewUploadFailed', {
                                upload_failed_reason: 1
                            });
                            console.log('ReviewUploadFailed', {
                                upload_failed_reason: 1
                            });
                        }
                        _ctx.next = 29;
                        return fetch("".concat(BASE_URL, "/review/submit"), {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                'content-type': 'application/json'
                            },
                            body: JSON.stringify(postData)
                        });
                    case 29:
                        res = _ctx.sent;
                        console.log(res);
                        if (!(res.status === 200 && res.ok)) {
                            _ctx.next = 39;
                            break;
                        }
                        // if (res.body)
                        clearTimeout(submitTimer);
                        _ctx.next = 35;
                        return res.json();
                    case 35:
                        data = _ctx.sent;
                        if (data.status === 200) {
                            ;
                            saveReviewFigure(form);
                            handleClose();
                            clearForm();
                            setLoading(false);
                            scrollToReviews();
                            toast.dark('Upload Successful! Your comment will be displayed pending approval.');
                            window === null || window === void 0 ? void 0 : (ref27 = window.sensors) === null || ref27 === void 0 ? void 0 : ref27.track('ReviewUploadSuccess', FormDrawer_objectSpread({
                            }, reviewReportData, submitReviews, nextReviews));
                            console.log('ReviewUploadSuccess', FormDrawer_objectSpread({
                            }, reviewReportData, submitReviews, nextReviews));
                            window === null || window === void 0 ? void 0 : (ref28 = window.sensors) === null || ref28 === void 0 ? void 0 : ref28.track('recaptcha_reviews_submit', {
                                score: data.body.score
                            });
                            console.log('recaptcha_reviews_submit', {
                                score: data.body.score
                            });
                        } else {
                            toast.dark("".concat(data.message || 'Server error, please feed back through the customer service plug-in'));
                            clearTimeout(submitTimer);
                            setLoading(false);
                        }
                        _ctx.next = 40;
                        break;
                    case 39:
                        if (res.status === 502) {
                            toast.dark("".concat(res.statusText || 'Bad Gateway'));
                            setLoading(false);
                        }
                    case 40:
                        _ctx.next = 48;
                        break;
                    case 42:
                        _ctx.prev = 42;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        window === null || window === void 0 ? void 0 : (ref29 = window.sensors) === null || ref29 === void 0 ? void 0 : ref29.track('ReviewUploadFailed', {
                            upload_failed_reason: 3
                        });
                        console.log(_ctx.t0);
                        setLoading(false);
                    case 48:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    42
                ]
            ]);
        }));
        return _handleSubmitReviews.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (step) {
            findFigure();
            marsWriteReviewBodySizesShow();
        }
    }, [
        step
    ]);
    // 控制google验证图标展示
    (0,react.useEffect)(function() {
        if (drawerOpen && step) {
            var ref;
            (ref = document.querySelector('.grecaptcha-badge')) === null || ref === void 0 ? void 0 : ref.classList.add('grecaptcha-badge__show');
        } else {
            var ref30;
            (ref30 = document.querySelector('.grecaptcha-badge')) === null || ref30 === void 0 ? void 0 : ref30.classList.remove('grecaptcha-badge__show');
        }
    }, [
        step,
        drawerOpen
    ]);
    /*
  useEffect(() => {
    if (drawerOpen) {
      if (loginEmail) {
        getUserFigure(loginEmail)
      }
      const uemail = getEmail()
      if (uemail) getUserFigure(uemail)
    }
  }, [drawerOpen])
  */ (0,react.useEffect)(function() {
        setBodyWords(computeCount(form.body));
        return function() {
            return clearTimeout(submitTimer);
        };
    }, [
        form.body
    ]);
    (0,react.useEffect)(function() {
        setNeedConfirm(!!form.body.length || !!value1.length);
    }, [
        form.body.length,
        value1.length
    ]);
    (0,react.useEffect)(function() {
        if (loginEmail) {
            setForm(FormDrawer_objectSpread({
            }, form, {
                email: loginEmail
            }));
        }
    }, [
        loginEmail
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        open: drawerOpen,
        anchor: upSm ? 'right' : 'bottom',
        onClose: // eslint-disable-next-line no-nested-ternary
        !loading ? needConfirm ? onConfirmClose : handleClose : function() {
            return null;
        },
        sx: {
            '.MuiPaper-root.MuiDrawer-paper': {
                height: '100vh'
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block w-full py-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center border-b-1 border-tag-grayef w-full h-14 fixed sm:w-96 top-0 z-10 px-3 bg-white text-black font-semibold select-none",
                    children: [
                        !loading && step === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute left-3.5 top-1/2 transform -translate-y-1/2 cursor-pointer",
                            onClick: function() {
                                return setStep(0);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                className: "w-4.5 h-4.5",
                                width: "11",
                                height: "20",
                                viewBox: "0 0 11 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M9.54919 1.51562L1.06391 10.0009L9.54919 18.4862",
                                    stroke: "black",
                                    strokeWidth: "1.5"
                                })
                            })
                        }) : null,
                        "Write A Review",
                        !loading && step === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer",
                            onClick: needConfirm ? onConfirmClose : handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vsc_index_esm/* VscClose */.ven, {
                                size: 26
                            })
                        }) : null
                    ]
                })
            }),
            step === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-screen sm:w-96 px-4 pt-6 pb-3 ".concat(loading ? 'text-opacity-90 pointer-events-none' : ''),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-11 h-11",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-11 h-11 items-start justify-center overflow-hidden relative",
                                    style: {
                                        paddingTop: "".concat(100 / 100 * 100, "%")
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute top-0 left-0 w-full h-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.C, {
                                            layout: "fill",
                                            objectFit: "cover",
                                            objectPosition: "top",
                                            src: pCover
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-block pl-3 min-w-0 overflow-hidden whitespace-nowrap overflow-ellipsis text-gray-400 font-semibold text-sm",
                                children: pTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center pt-3.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: averageRatingRef,
                                tabIndex: -1,
                                className: "font-semibold text-sm focus:text-tag-red-deep",
                                onClick: function() {
                                    return setOpenMoreRating(true);
                                },
                                children: "Overall Rating"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                type: "outline",
                                value: form.averageRating,
                                length: 5,
                                openHalf: false,
                                onSelect: function(e) {
                                    setForm(FormDrawer_objectSpread({
                                    }, form, {
                                        averageRating: e
                                    }));
                                    setOpenMoreRating(true);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                        in: openMoreRating,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center pt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-400 font-medium text-xs focus:text-tag-red-deep",
                                        ref: costEffectiveRef,
                                        tabIndex: -1,
                                        children: "Value For Cost"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                        type: "fill",
                                        value: form.costEffective,
                                        length: 5,
                                        openHalf: false,
                                        onSelect: function(e) {
                                            return setForm(FormDrawer_objectSpread({
                                            }, form, {
                                                costEffective: e
                                            }));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center pt-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-400 font-medium text-xs focus:text-tag-red-deep",
                                        ref: comfortRef,
                                        tabIndex: -1,
                                        children: "Comfort Level"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                        type: "fill",
                                        value: form.comfort,
                                        length: 5,
                                        openHalf: false,
                                        onSelect: function(e) {
                                            return setForm(FormDrawer_objectSpread({
                                            }, form, {
                                                comfort: e
                                            }));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center pt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-400 font-medium text-xs focus:text-tag-red-deep",
                                        ref: stretchRef,
                                        tabIndex: -1,
                                        children: "Elasticity"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                        value: form.stretch,
                                        className: "-mx-1 flex flex-wrap justify-end",
                                        arr: STRETCH_ARR,
                                        onSelect: function(index) {
                                            return setForm(FormDrawer_objectSpread({
                                            }, form, {
                                                stretch: STRETCH_ARR[index].value
                                            }));
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex justify-between items-center pt-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-gray-400 font-medium text-xs focus:text-tag-red-deep",
                                        ref: fittingRef,
                                        tabIndex: -1,
                                        children: "Fit"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton, {
                                        value: form.fitting,
                                        className: "-mx-1 flex flex-wrap justify-end",
                                        arr: FITTING_ARR,
                                        onSelect: function(index) {
                                            return setForm(FormDrawer_objectSpread({
                                            }, form, {
                                                fitting: FITTING_ARR[index].value
                                            }));
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full relative mt-4 border-t border-t-1 border-tag-grayef pt-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                ref: bodyRef,
                                name: "body",
                                placeholder: "",
                                className: "w-full h-24 mb-3 outline-none text-sm resize-none leading-tight font-medium",
                                maxLength: 2000,
                                defaultValue: form === null || form === void 0 ? void 0 : form.body,
                                onChange: setFormValues,
                                onBlur: form.body ? checkValue : function() {
                                    return setShowError(function() {
                                        return FormDrawer_objectSpread({
                                        }, showError, {
                                            body: false
                                        });
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute top-4 left-0 text-sm font-medium pointer-events-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex text-gray-400".concat(!(showError === null || showError === void 0 ? void 0 : showError.body) && !form.body.length ? '' : ' hidden'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                className: "mt-0.5 w-6 inline-block",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                        x: "2.66663",
                                                        y: "12.3335",
                                                        width: "10.6667",
                                                        height: "1",
                                                        fill: "#999999"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M1.83337 12.8335V11.0406L10.8334 2.0406L12.6263 3.8335L3.62627 12.8335H1.83337Z",
                                                        stroke: "#999999"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pl-2",
                                                children: "You can write a review based on fit, style, comfort, quality, and affordability."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-tag-red-light ".concat((showError === null || showError === void 0 ? void 0 : showError.body) ? '' : 'hidden'),
                                        children: "Please write down your review"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-xs text-gray-400 pb-0.5 ".concat(bodyWords < 30 ? '' : ' hidden'),
                                style: {
                                    transform: 'scale(0.8333)',
                                    transformOrigin: 'left top'
                                },
                                children: [
                                    "*Write ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "text-tag-orange-deep",
                                        children: [
                                            30 - bodyWords,
                                            " "
                                        ]
                                    }),
                                    "more words for a chance at a top review!"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full pb-16",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_picker, {
                            value: value1,
                            onChange: onChange,
                            multiple: true,
                            max: 8,
                            mode: "cover",
                            // @ts-ignore
                            onUpload: onUpload,
                            quality: 0.6,
                            className: "grid grid-cols-4 gap-x-2 gap-y-2 mx-0",
                            outputWidth: 1024,
                            outputHeight: 2048,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                className: "w-full h-full cursor-pointer",
                                width: "80",
                                height: "80",
                                viewBox: "0 0 80 80",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                        width: "80",
                                        height: "80",
                                        fill: "#F5F5F5"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("text", {
                                        x: "22",
                                        y: "63",
                                        fontSize: "12",
                                        fill: "#666666",
                                        children: "Photo"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M28 42H49.3334H52V18H49.3334H28L28 20.6667V39.3333V42ZM34.6667 32.6667L37.8174 35.8173L42.6667 28.6667L49.3334 38H30.6667L34.6667 32.6667Z",
                                        fill: "#666666"
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            step === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-screen sm:w-96 pb-20 ".concat(loading ? 'text-opacity-90 pointer-events-none' : ''),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 py-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex text-sm flex-wrap mb-1 font-medium flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "leading-1 space-x-2 text-black font-semibold",
                                        children: "Your Measurements (Optional)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-xs space-x-2 text-gray-400",
                                        children: "Your input helps other shoppers"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-flex w-full mt-3.5 items-center justify-between text-xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "leading-1 space-x-2 text-sm font-medium",
                                        children: "Height"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "height",
                                        onChange: function(e) {
                                            return setFormValues(e, true);
                                        },
                                        // defaultValue={form.height}
                                        value: form.height,
                                        className: "w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ".concat(form.height === -1 && 'text-gray-400'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                children: "Please Choose One"
                                            }),
                                            figure === null || figure === void 0 ? void 0 : (ref14 = figure.heights) === null || ref14 === void 0 ? void 0 : ref14.map(function(i, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: idx,
                                                    children: i
                                                }, "height".concat(idx));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                        className: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer",
                                        color: "inherit",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-flex w-full mt-4 items-center justify-between text-xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "leading-1 space-x-2 text-sm font-medium",
                                        children: "Weight"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "weight",
                                        onChange: function(e) {
                                            return setFormValues(e, true);
                                        },
                                        // defaultValue={form.weight}
                                        value: form.weight,
                                        className: "w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ".concat(form.weight === -1 && 'text-gray-400'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                children: "Please Choose One"
                                            }),
                                            figure === null || figure === void 0 ? void 0 : (ref1 = figure.weights) === null || ref1 === void 0 ? void 0 : ref1.map(function(i, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: idx,
                                                    children: i
                                                }, "weight".concat(idx));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                        className: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer",
                                        color: "inherit",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-flex w-full mt-4 items-center justify-between text-xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "leading-1 space-x-2 text-sm font-medium",
                                        children: "Bust"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "bust",
                                        onChange: function(e) {
                                            return setFormValues(e, true);
                                        },
                                        // defaultValue={form.bust}
                                        value: form.bust,
                                        className: "w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ".concat(form.bust === -1 && 'text-gray-400'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                children: "Please Choose One"
                                            }),
                                            figure === null || figure === void 0 ? void 0 : (ref2 = figure.busts) === null || ref2 === void 0 ? void 0 : ref2.map(function(i, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: idx,
                                                    children: i
                                                }, "bust".concat(idx));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                        className: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer",
                                        color: "inherit",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-flex w-full mt-4 items-center justify-between text-xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "leading-1 space-x-2 text-sm font-medium",
                                        children: "Waist"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "waist",
                                        onChange: function(e) {
                                            return setFormValues(e, true);
                                        },
                                        // defaultValue={form.waist}
                                        value: form.waist,
                                        className: "w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ".concat(form.waist === -1 && 'text-gray-400'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                children: "Please Choose One"
                                            }),
                                            figure === null || figure === void 0 ? void 0 : (ref3 = figure.waists) === null || ref3 === void 0 ? void 0 : ref3.map(function(i, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: idx,
                                                    children: i
                                                }, "waist".concat(idx));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                        className: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer",
                                        color: "inherit",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative inline-flex w-full mt-4 items-center justify-between text-xs",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "leading-1 space-x-2 text-sm font-medium",
                                        children: "Hips"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "hips",
                                        onChange: function(e) {
                                            return setFormValues(e, true);
                                        },
                                        // defaultValue={form.hips}
                                        value: form.hips,
                                        placeholder: "Please Choose One",
                                        className: "w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ".concat(form.hips === -1 && 'text-gray-400'),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: -1,
                                                children: "Please Choose One"
                                            }),
                                            figure === null || figure === void 0 ? void 0 : (ref4 = figure.hips) === null || ref4 === void 0 ? void 0 : ref4.map(function(i, idx) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                                    value: idx,
                                                    children: i
                                                }, "hips".concat(idx));
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                        className: "absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer",
                                        color: "inherit",
                                        size: 16
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-screen sm:w-96 pt-1.5 pb-1 bg-tag-grayf5"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 pt-6",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex text-sm flex-wrap mb-1 font-medium",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "leading-1 space-x-2",
                                    children: "Name"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        ref: nameRef,
                                        type: "text",
                                        name: "name",
                                        placeholder: "Enter your name (public)",
                                        className: "mt-1 border-tag-grayccc border-1 px-4 w-full outline-none text-sm text-black font-medium",
                                        maxLength: 200,
                                        defaultValue: form === null || form === void 0 ? void 0 : form.name,
                                        onChange: setFormValues,
                                        onBlur: checkValue,
                                        style: {
                                            height: '50px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pt-2 text-xs text-tag-red-deep ".concat((showError === null || showError === void 0 ? void 0 : showError.name) ? '' : 'hidden'),
                                        children: "Please enter your name."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inline-flex text-sm flex-wrap mt-4 mb-1 font-medium",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "leading-1 space-x-2",
                                    children: "Email"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        ref: emailRef,
                                        type: "text",
                                        name: "email",
                                        placeholder: "Enter your email (private)",
                                        className: "mt-1 border-tag-grayccc border-1 px-3.5 w-full outline-none text-sm text-black font-medium",
                                        maxLength: 200,
                                        // defaultValue={form?.email}
                                        value: form === null || form === void 0 ? void 0 : form.email,
                                        onChange: setFormValues,
                                        onBlur: checkValue,
                                        style: {
                                            height: '50px'
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pt-2 text-xs text-tag-red-deep ".concat((showError === null || showError === void 0 ? void 0 : showError.email) ? '' : 'hidden'),
                                        children: "".concat(!form.email || form.email === ' ' ? 'Please enter your email.' : 'Please enter a valid email address.')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-xs text-gray-400 pt-2 pb-0.5 w-full hidden",
                                children: [
                                    "This site is protected by reCAPTCHA and the Google",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "https://policies.google.com/privacy",
                                        className: "text-tag-orange-deep",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            ' ',
                                            "Privacy Policy"
                                        ]
                                    }),
                                    ' ',
                                    "and",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        href: "https://policies.google.com/terms",
                                        className: "text-tag-orange-deep",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: [
                                            ' ',
                                            "Terms of Service"
                                        ]
                                    }),
                                    ' ',
                                    "apply."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center w-full fixed sm:w-96 bottom-0 z-50 px-3 bg-black text-white select-none ".concat(loading ? 'text-white text-opacity-90 bg-gray-400 pointer-events-none cursor-not-allowed' : 'cursor-pointer'),
                style: {
                    height: '50px'
                },
                onClick: function() {
                    return handleSubmitReviews();
                },
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute -left-9 top-1/2 transform -translate-y-1/2 flex items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "animate-spin inline-block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineLoading */.xz6, {
                                    size: 24
                                })
                            })
                        }),
                        "Submit"
                    ]
                }) : step === 0 && 'Next' || step === 1 && 'Submit'
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/products/reviews/ReviewList.tsx








// eslint-disable-next-line import/prefer-default-export
var ReviewList = function(param) {
    var figure = param.figure, reviewList = param.reviewList, _previewLimit = param.previewLimit, previewLimit = _previewLimit === void 0 ? 6 : _previewLimit, disableViewMore = param.disableViewMore, className = param.className, _isExtension = param.isExtension, isExtension = _isExtension === void 0 ? false : _isExtension;
    var ref3 = (0,react.useState)(false), previewOpen = ref3[0], setPreviewOpen = ref3[1];
    var ref1 = (0,react.useState)([]), urlList = ref1[0], setUrlList = ref1[1];
    var ref2 = (0,react.useState)(0), photoIndex = ref2[0], setPhotoIndex = ref2[1];
    var onClose = function() {
        setTimeout(function() {
            return setPreviewOpen(function(val) {
                return !val;
            });
        }, 300);
        if (isExtension) return;
        window.parent.postMessage({
            reviews: 'CloseFullScreen'
        }, '*');
    };
    var previewHandle = function(arr, index) {
        console.log(arr);
        setUrlList(arr.map(function(i) {
            return i.url;
        }));
        setPhotoIndex(index);
        setPreviewOpen(true);
    };
    var getFigureObject = function(fig) {
        return JSON.parse(fig);
    };
    var getFigureKeys = function(fig) {
        return Object.keys(getFigureObject(fig));
    };
    var chartAtFirstWord = function(name) {
        return name.charAt(0).toUpperCase() + name.slice(1, -1);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(className, " flex flex-wrap"),
        children: [
            reviewList.map(function(i, ikey) {
                var ref;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-wrap py-4 w-full border-b-1 border-tag-grayef",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-shrink-0 flex justify-center items-center w-8 h-8 border rounded-full border-tag-grayef",
                                    children: (i.reviewerName || '?').slice(0, 1).toUpperCase()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-wrap pl-2 min-w-0 w-full h-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-nowrap w-full min-w-0 text-gray-400 text-xs font-medium",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block min-w-0 overflow-hidden whitespace-nowrap overflow-ellipsis",
                                                    children: (i === null || i === void 0 ? void 0 : i.reviewerName) || 'Anonymous'
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-block px-1.5 transform scale-150",
                                                    children: "\xb7"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: dayjs_min_default().tz((i === null || i === void 0 ? void 0 : i.createdAt) || 0, dayjs_min_default().tz.guess()).format('MM/DD/YYYY')
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                            type: "outline",
                                            value: i.rating.toFixed(1),
                                            length: 5,
                                            openHalf: false,
                                            className: "w-full star-xxs"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full",
                            children: [
                                !!(i === null || i === void 0 ? void 0 : i.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 -mb-2 text-black font-semibold text-14",
                                    children: unescape(i === null || i === void 0 ? void 0 : i.title)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 text-xs text-black font-medium",
                                    children: unescape(i === null || i === void 0 ? void 0 : i.body)
                                }),
                                (i === null || i === void 0 ? void 0 : i.medias.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-3 w-full grid grid-cols-3 gap-x-1 gap-y-1",
                                    children: i === null || i === void 0 ? void 0 : i.medias.filter(function(m) {
                                        return m.type === 0;
                                    }).slice(0, previewLimit).map(function(m, mkey) {
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex w-full items-start justify-center overflow-hidden relative",
                                            style: {
                                                paddingTop: "".concat(100 / 100 * 100, "%")
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute top-0 left-0 w-full h-full cursor-pointer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* BaseImage */.Z, {
                                                        layout: "fill",
                                                        objectFit: "cover",
                                                        src: m.url,
                                                        onClick: function() {
                                                            setTimeout(function() {
                                                                return previewHandle(i === null || i === void 0 ? void 0 : i.medias.filter(function(item) {
                                                                    return item.type === 0;
                                                                }), mkey);
                                                            }, 50);
                                                            if (isExtension) return;
                                                            window.parent.postMessage({
                                                                reviews: 'OpenFullScreen'
                                                            }, '*');
                                                        }
                                                    })
                                                }),
                                                !disableViewMore && (i === null || i === void 0 ? void 0 : i.medias.length) > previewLimit && mkey === previewLimit - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "absolute top-0 left-0 flex justify-center items-center w-full h-full text-white font-medium pointer-events-none",
                                                    style: {
                                                        background: 'rgba(0,0,0,0.6)'
                                                    },
                                                    children: [
                                                        (i === null || i === void 0 ? void 0 : i.medias.length) - (previewLimit - 1),
                                                        " Left",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineArrowForwardIos */.Djl, {
                                                            color: "inherit",
                                                            fontSize: "15",
                                                            className: "ml-0.5"
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }, i.id + mkey));
                                    })
                                }) : null,
                                (i === null || i === void 0 ? void 0 : i.figure) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full min-w-0 mt-0.5 text-gray-400 text-xs font-medium -mb-1",
                                    style: {
                                        transform: 'scale(0.8333)',
                                        transformOrigin: 'left bottom'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-wrap w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "mb-1 flex w-1/2",
                                                children: [
                                                    "Overall Fit:",
                                                    ' ',
                                                    (i === null || i === void 0 ? void 0 : i.extendForm) && ((ref = FITTING_ARR.find(function(item) {
                                                        return item.value === JSON.parse(i.extendForm).fitting;
                                                    })) === null || ref === void 0 ? void 0 : ref.label) || 'Unset'
                                                ]
                                            }),
                                            getFigureKeys(i.figure).map(function(item) {
                                                return (figure === null || figure === void 0 ? void 0 : figure[item][getFigureObject(i.figure)[item]]) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-1 flex w-1/2",
                                                    children: [
                                                        chartAtFirstWord(item),
                                                        item === 'hips' && 's',
                                                        ":",
                                                        ' ',
                                                        figure === null || figure === void 0 ? void 0 : figure[item][getFigureObject(i.figure)[item]]
                                                    ]
                                                });
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }, i.id + ikey));
            }),
            previewOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(PhotoSwiper/* default */.Z, {
                images: urlList,
                open: previewOpen,
                onOpenChange: onClose,
                initialSlide: photoIndex
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(93808);
;// CONCATENATED MODULE: ./src/components/products/reviews/ProgressBar.tsx


/**
 * 进度条组件
 */ // eslint-disable-next-line import/prefer-default-export
var ProgressBar = function(param) {
    var _percent = param.percent, percent = _percent === void 0 ? 0 : _percent, _className = param.className, className = _className === void 0 ? '' : _className, _barColor = param.barColor, barColor = _barColor === void 0 ? 'black' : _barColor, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? '#e5e5e5' : _bgColor;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: className,
        style: {
            cursor: 'none',
            background: "linear-gradient(to right, ".concat(barColor, " ").concat(percent, "%, ").concat(bgColor, " ").concat(percent, "%)")
        }
    });
};

;// CONCATENATED MODULE: ./src/components/products/reviews/RatingBox.tsx




/**
 * 打分组件 Ranting
 * value range：1 ≤ value ≤ length
 */ // eslint-disable-next-line import/prefer-default-export
var RatingBox = function(param) {
    var _reviewAverage = param.reviewAverage, reviewAverage = _reviewAverage === void 0 ? 0 : _reviewAverage, reviewList = param.reviewList, _reviewFigure = param.reviewFigure, reviewFigure = _reviewFigure === void 0 ? '' : _reviewFigure, _showPercentBox = param.showPercentBox, showPercentBox = _showPercentBox === void 0 ? false : _showPercentBox, _preRight = param.preRight, preRight = _preRight === void 0 ? 'pl-14' : _preRight;
    return showPercentBox ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex sm:flex-nowrap md:flex-wrap flex-wrap items-center pl-4 py-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-32px font-semibold",
                        children: (reviewAverage || (reviewList.length ? reviewList.map(function(i) {
                            return i.rating;
                        }).reduce(function(a, b) {
                            return a + b;
                        }) / reviewList.length : 0)).toFixed(1) || 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                        type: "outline",
                        value: (reviewAverage || (reviewList.length ? reviewList.map(function(i) {
                            return i.rating;
                        }).reduce(function(a, b) {
                            return a + b;
                        }) / reviewList.length : 0)).toFixed(1) || 0,
                        length: 5,
                        openHalf: true,
                        func: function(v) {
                            return Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2;
                        },
                        className: "star-sm flex flex-nowrap sm:pl-3 md:pl-0 pl-0 my-1"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap pr-4 py-3.5 ".concat(preRight),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "my-0.5 text-xs text-gray-400",
                        children: "How did the item fit?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex items-center text-xs text-black",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-20 -mr-0.5",
                                children: "Small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                percent: reviewFigure.smPer,
                                className: "h-2 flex-grow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-7 my-0.5 ml-2 text-12",
                                children: [
                                    reviewFigure.smPer,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex items-center text-xs text-black",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-20 -mr-0.5",
                                children: "True to size"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                percent: reviewFigure.truePer,
                                className: "h-2 flex-grow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-7 my-0.5 ml-2 text-12",
                                children: [
                                    reviewFigure.truePer,
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex items-center text-xs text-black",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-20 -mr-0.5",
                                children: "Large"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                                percent: reviewFigure.lgPer,
                                className: "h-2 flex-grow"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-7 my-0.5 ml-2 text-12",
                                children: [
                                    reviewFigure.lgPer,
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-5 pl-6 text-32px font-semibold",
                children: (reviewAverage || (reviewList.length ? reviewList.map(function(i) {
                    return i.rating;
                }).reduce(function(a, b) {
                    return a + b;
                }) / reviewList.length : 0)).toFixed(1) || 0
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                type: "outline",
                value: (reviewAverage || (reviewList.length ? reviewList.map(function(i) {
                    return i.rating;
                }).reduce(function(a, b) {
                    return a + b;
                }) / reviewList.length : 0)).toFixed(1) || 0,
                length: 5,
                openHalf: true,
                func: function(v) {
                    return Math[v < 4.8 ? 'floor' : 'ceil'](v * 2) / 2;
                },
                className: "py-5 pr-6"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/products/reviews/ReviewListDrawer.tsx










// import { Rating } from './Rating'




function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ReviewListDrawer_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function ReviewListDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ReviewListDrawer_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ReviewListDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ReviewListDrawer_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ReviewListDrawer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReviewListDrawer_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function ReviewListDrawer_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function ReviewListDrawer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReviewListDrawer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function ReviewListDrawer_toConsumableArray(arr) {
    return ReviewListDrawer_arrayWithoutHoles(arr) || ReviewListDrawer_iterableToArray(arr) || ReviewListDrawer_nonIterableSpread();
}
// 简易loading
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Loading = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center items-center w-full sm:w-96 py-4",
        style: {
            height: '56px'
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "animate-spin inline-block",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineLoading */.xz6, {
                size: 24
            })
        })
    });
};
// eslint-disable-next-line import/prefer-default-export
var ReviewListDrawer = function(param1) {
    var figure = param1.figure, drawerOpen = param1.drawerOpen, onClose = param1.onClose, // productId,
    pHandle = param1.pHandle, reviewReportData = param1.reviewReportData, _isExtension = param1.isExtension, isExtension = _isExtension === void 0 ? false : _isExtension;
    var handleSortTypeSelect = function handleSortTypeSelect(e) {
        var ref;
        setIsLoading(true);
        setCurrentFilter(e.target.value);
        setReviewList([]);
        window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('ReviewSortMethodClick', ReviewListDrawer_objectSpread({
        }, reviewReportData, {
            // @ts-ignore
            sort_method: SORT_ARR.find(function(item) {
                return item.value === e.target.value;
            }).label
        }));
        console.log('ReviewSortMethodClick', ReviewListDrawer_objectSpread({
        }, reviewReportData, {
            // @ts-ignore
            sort_method: SORT_ARR.find(function(item) {
                return item.value === e.target.value;
            }).label
        }));
    };
    var ref11;
    var size =  true ? Math.max(+(((ref11 = window === null || window === void 0 ? void 0 : window.innerHeight) !== null && ref11 !== void 0 ? ref11 : 1000) / 100).toFixed(0), 10) : 0 // 每页条数
    ;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(dayjs_min_default()()), openTime = ref2[0], setOpenTime = ref2[1];
    var ref3 = (0,react.useState)(1), pageIndex = ref3[0], setPageIndex = ref3[1];
    var ref4 = (0,react.useState)(0), reviewCacheCount = ref4[0], setReviewCacheCount = ref4[1];
    var ref5 = (0,react.useState)(''), currentFilter = ref5[0], setCurrentFilter = ref5[1];
    var ref6 = (0,react.useState)(0), reviewAverage = ref6[0], setReviewAverage = ref6[1];
    var ref7 = (0,react.useState)(null), reviewCount = ref7[0], setReviewCount = ref7[1];
    var ref8 = (0,react.useState)([]), reviewList = ref8[0], setReviewList = ref8[1];
    var ref9 = (0,react.useState)({
    }), reviewFigure = ref9[0], setReviewFigure = ref9[1];
    var controllerRef = (0,react.useRef)();
    var ref10 = (0,react.useState)(false), showPercentBox = ref10[0], setShowPercentBox = ref10[1];
    var handleClose = function() {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
        onClose(dayjs_min_default()().diff(openTime, 'milliseconds'));
    };
    function getReviewList(sortKey, page, moreParam) {
        return _getReviewList.apply(this, arguments);
    }
    function _getReviewList() {
        _getReviewList = ReviewListDrawer_asyncToGenerator(runtime_default().mark(function _callee(sortKey, page, moreParam) {
            var ref, param2, res, data, newReviewList, fig, computedPercent, ref12, smPer, lgPer, truePer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (controllerRef.current) {
                            controllerRef.current.abort();
                        }
                        controllerRef.current = new AbortController();
                        _ctx.prev = 2;
                        ;
                        setIsLoading(true);
                        param2 = (0,addQueryParam/* default */.Z)("".concat(BASE_URL, "/review?").concat(moreParam), 'handle', pHandle);
                        param2 = sortKey ? (0,addQueryParam/* default */.Z)(param2, 'sortKey', sortKey) : param2;
                        param2 = page ? (0,addQueryParam/* default */.Z)(param2, 'offset', Math.max(page - 1, 0) * size) : param2;
                        _ctx.next = 10;
                        return fetch("".concat(param2, "&limit=").concat(size), {
                            signal: (ref = controllerRef.current) === null || ref === void 0 ? void 0 : ref.signal
                        });
                    case 10:
                        res = _ctx.sent;
                        if (!(res.status === 200 && res.ok)) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 14;
                        return res.json();
                    case 14:
                        data = _ctx.sent;
                        if (data.status === 200) {
                            setReviewCount(data.body.count);
                            setReviewAverage(data.body.average);
                            newReviewList = ReviewListDrawer_toConsumableArray(reviewList).concat(ReviewListDrawer_toConsumableArray(data.body.items));
                            setReviewList(newReviewList);
                            fig = data.body.reviewFit;
                            if (fig && fig.total > 0) {
                                computedPercent = function(total, arrs, param) {
                                    var fixed = param === void 0 ? 0 : param;
                                    return arrs.map(function(i) {
                                        return Number((i * 100 / total).toFixed(fixed));
                                    });
                                };
                                ref12 = _slicedToArray(computedPercent(fig.total, [
                                    fig.small,
                                    // fig.true_to_size,
                                    fig.large, 
                                ]), 2), smPer = ref12[0], lgPer = ref12[1];
                                truePer = 100 - smPer - lgPer;
                                setReviewFigure(ReviewListDrawer_objectSpread({
                                }, fig, {
                                    smPer: smPer,
                                    truePer: truePer,
                                    lgPer: lgPer
                                }));
                                setShowPercentBox(true);
                            }
                            console.log(reviewList, data.body.items);
                            setPageIndex(Math.ceil((newReviewList.length - reviewCacheCount) / size) || 1);
                            controllerRef.current = null;
                        // setPageIndex(pageIndex + 1)
                        } else {
                            material_react_toastify_cjs_production_min.toast.error(data.message || 'Server error, please feed back through the customer service plug-in');
                        }
                    case 16:
                        _ctx.next = 22;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](2);
                        console.log(_ctx.t0);
                        if (typeof navigator !== 'undefined' && !navigator.onLine) {
                            material_react_toastify_cjs_production_min.toast.dark('Oops, fetch data failed. Please check your network and try again.');
                        }
                    case 22:
                        setIsLoading(false);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    18
                ]
            ]);
        }));
        return _getReviewList.apply(this, arguments);
    }
    (0,react.useEffect)(function() {
        if (drawerOpen) {
            // setPageIndex(1)
            setReviewList([]);
            setCurrentFilter(SORT_ARR[0].value);
        } else {
            setReviewList([]);
            setCurrentFilter('');
            console.log('close');
        }
    }, [
        drawerOpen
    ]);
    // useEffect(() => {
    //   if (drawerOpen) {
    //     setPageIndex(
    //       Math.ceil((reviewList.length - reviewCacheCount) / size) || 1
    //     )
    //   }
    // }, [reviewList.length])
    (0,react.useEffect)(function() {
        if (drawerOpen) {
            setReviewList([]);
            setPageIndex(1);
            getReviewList(undefined, 1, currentFilter);
        }
    }, [
        currentFilter
    ]);
    (0,react.useEffect)(function() {
        if ( false || !drawerOpen) return;
        setOpenTime(dayjs_min_default()());
        var reviewCache = get2HoursLocalReviews(pHandle);
        var IdCacheList = reviewCache.map(function(i) {
            return i.id;
        });
        var excludeCacheIdReviews = reviewList.filter(function(i) {
            return !IdCacheList.includes(i.id);
        });
        var finalList = ReviewListDrawer_toConsumableArray(reviewCache).concat(ReviewListDrawer_toConsumableArray(excludeCacheIdReviews));
        setReviewList(finalList);
        setReviewCacheCount(reviewCache.length);
    // setReviewList([])
    }, [
        drawerOpen,
        reviewList.length
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        open: drawerOpen,
        anchor: "right",
        onClose: handleClose,
        sx: {
            '.MuiDrawer-paper': {
                overflow: 'hidden'
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block w-full py-7",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center border-b-1 border-gray-100 w-full h-14 fixed sm:w-96 top-0 z-10 px-3 bg-white text-black font-semibold",
                    children: [
                        "Reviews",
                        reviewCount ? " (".concat(reviewCount > 999 ? '999+' : reviewCount, ")") : '',
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute left-4 top-1/2 transform -translate-y-1/2 cursor-pointer",
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "11",
                                height: "20",
                                viewBox: "0 0 11 20",
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M9.54907 1.51465L1.06379 9.99993L9.54907 18.4852",
                                    stroke: "black",
                                    strokeWidth: "1.5"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-wrap w-screen sm:w-96",
                style: {
                    height: 'calc(100vh - 56px)'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-grow-0 justify-between items-center w-full pl-0 bg-tag-grayf5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox, {
                            reviewList: reviewList,
                            reviewFigure: reviewFigure,
                            reviewAverage: reviewAverage,
                            showPercentBox: showPercentBox
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex border-b border-tag-grayef",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "inline-flex flex-1 my-2 px-2 items-center justify-end text-xs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    onChange: handleSortTypeSelect,
                                    defaultValue: SORT_ARR[0].value,
                                    className: "bg-transparent outline-none h-6 mr-0.5 text-12 text-right font-medium cursor-pointer",
                                    children: SORT_ARR.map(function(i, idx) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                            value: i.value,
                                            children: i.label
                                        }, idx);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                                    color: "inherit",
                                    size: 16
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex-1 overflow-y-auto",
                        id: "reviewListInfiniteScroll",
                        children: [
                            isLoading && !reviewList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                            }) : null,
                            reviewList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                                scrollableTarget: "reviewListInfiniteScroll",
                                next: function() {
                                    console.log('next ', pageIndex + 1);
                                    setTimeout(function() {
                                        return getReviewList(undefined, pageIndex + 1, currentFilter);
                                    }, 50);
                                },
                                hasMore: Math.max(pageIndex, 0) * size < reviewCount,
                                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
                                }),
                                dataLength: reviewList.length - reviewCacheCount || size,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewList, {
                                    figure: figure,
                                    reviewList: reviewList,
                                    className: "px-3",
                                    isExtension: isExtension
                                })
                            }, currentFilter) : null,
                            !isLoading && Math.max(pageIndex, 0) * size >= reviewCount && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full py-4 text-center text-gray-400 text-xs font-medium",
                                children: "This is the end"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/products/ProductsReviewsNew.tsx


/* eslint-disable no-nested-ternary */ /* eslint-disable react/jsx-no-target-blank */ /* eslint-disable jsx-a11y/anchor-has-content */ /* eslint-disable jsx-a11y/anchor-is-valid */ 












// import { Rating } from './reviews/Rating'




// import { ProgressBar } from './reviews/ProgressBar'

function ProductsReviewsNew_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function ProductsReviewsNew_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function ProductsReviewsNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ProductsReviewsNew_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ProductsReviewsNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ProductsReviewsNew_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ProductsReviewsNew_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProductsReviewsNew_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function ProductsReviewsNew_iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function ProductsReviewsNew_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function ProductsReviewsNew_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function ProductsReviewsNew_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProductsReviewsNew_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ProductsReviewsNew_slicedToArray(arr, i) {
    return ProductsReviewsNew_arrayWithHoles(arr) || ProductsReviewsNew_iterableToArrayLimit(arr, i) || ProductsReviewsNew_nonIterableRest();
}
function ProductsReviewsNew_toConsumableArray(arr) {
    return ProductsReviewsNew_arrayWithoutHoles(arr) || ProductsReviewsNew_iterableToArray(arr) || ProductsReviewsNew_nonIterableSpread();
}
// import { useRecaptchaHook } from '../../hooks/useRecaptchaHook'
// import { useGetProtectedInfoHook } from '../../hooks/useGetProtectedInfoHook'
dayjs_min_default().extend((utc_default()));
dayjs_min_default().extend((timezone_default()));
var reviewReportData = {
};
// 回调函数
// eslint-disable-next-line consistent-return
function receiveMessageFromIndex(event) {
    if (event.data.reviewRect) {
        var // @ts-ignore
        ref;
        var reviewsWrapper = (ref = window.document.querySelector('.reviews-wrapper')) === null || ref === void 0 ? void 0 : ref.style;
        reviewsWrapper.width = "".concat(event.data.reviewRect.width, "px");
        reviewsWrapper.height = "".concat(event.data.reviewRect.height, "px");
        reviewsWrapper.position = 'absolute';
        reviewsWrapper.left = "".concat(event.data.reviewRect.left, "px");
        reviewsWrapper.top = "".concat(event.data.reviewRect.top, "px");
        return null;
    }
    if (event.data.reviewRectClear) {
        var // @ts-ignore
        ref1;
        var reviewsWrapper1 = (ref1 = window.document.querySelector('.reviews-wrapper')) === null || ref1 === void 0 ? void 0 : ref1.style;
        setTimeout(function() {
            reviewsWrapper1.width = "auto";
            reviewsWrapper1.height = "auto";
            reviewsWrapper1.position = 'relative';
            reviewsWrapper1.left = "0";
            reviewsWrapper1.top = "0";
        }, 300);
        return null;
    }
}
// 监听message事件
if (true) window.addEventListener('message', receiveMessageFromIndex, false);
function disableUserEvent() {
    window.document.body.style.pointerEvents = 'none';
    setTimeout(function() {
        window.document.body.style.pointerEvents = 'unset';
    }, 200);
}
var ProductsReviews = function(param2) {
    var pData = param2.pData, pTitle = param2.pTitle, pid = param2.pid, pHandle = param2.pHandle, _isExtension = param2.isExtension, isExtension = _isExtension === void 0 ? false : _isExtension, onInit = param2.onInit;
    var getMainData = // // @ts-ignore
    // const token = useRecaptchaHook(process.env.NEXT_PUBLIC_SITE_KEY)
    // const protectedInfo = useGetProtectedInfoHook(token)
    // console.log('@@@@ ', token, protectedInfo)
    function getMainData() {
        fetch("".concat(BASE_URL, "/review/figure")).then(function(res) {
            return res.json();
        }).then(function(data) {
            var ref, ref15;
            if (data === null || data === void 0 ? void 0 : (ref = data.body) === null || ref === void 0 ? void 0 : (ref15 = ref.bands) === null || ref15 === void 0 ? void 0 : ref15.length) {
                setFigure(data.body);
            } else {
                material_react_toastify_cjs_production_min.toast.error('Failed to fetch figure data');
            }
        }).catch(function(err) {
            // eslint-disable-next-line no-console
            console.log(err);
            material_react_toastify_cjs_production_min.toast.error('Failed to fetch figure data');
        });
    };
    var registerMessage = function registerMessage() {
        window.addEventListener('message', function(data) {
            var datas = data.data;
            switch(datas.action){
                case 'openReviewList':
                    setReviewListDrawer(true);
                    break;
                default:
                    break;
            }
        });
    };
    var ref16 = (0,react.useState)(0), reviewCount = ref16[0], setReviewCount = ref16[1];
    var ref2 = (0,react.useState)(0), reviewAverage = ref2[0], setReviewAverage = ref2[1];
    var ref3 = (0,react.useState)(0), fetchCount = ref3[0], setFetchCount = ref3[1];
    var ref4 = (0,react.useState)([]), reviewList = ref4[0], setReviewList = ref4[1];
    var ref5 = (0,react.useState)({
    }), reviewFigure = ref5[0], setReviewFigure = ref5[1];
    var ref6 = (0,react.useState)({
    }), figure = ref6[0], setFigure = ref6[1];
    // const [reviewCacheList, setReviewCacheList] = useState<any[]>([])
    var ref7 = (0,react.useState)(''), productId = ref7[0], setProductId = ref7[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref8 = (0,react.useState)(true), isLoading = ref8[0], setIsLoading = ref8[1];
    var ref9 = (0,react.useState)(false), isLoaded = ref9[0], setIsLoaded = ref9[1];
    var ref10 = (0,react.useState)(true), showPercentBox = ref10[0], setShowPercentBox = ref10[1];
    var ref11 = (0,react.useState)(false), formDrawerOpen = ref11[0], setFormDrawerOpen = ref11[1];
    var ref12 = (0,react.useState)(false), reviewListDrawer = ref12[0], setReviewListDrawer = ref12[1];
    var upSm = useWindowSize().upSm;
    (0,react.useEffect)(function() {
        if (pid) {
            saveReview([]) // Clear expired reviews cache
            ;
            setProductId(window.atob(pid).split('/')[4]);
            if (new URLSearchParams(window.location.search).get('target') === 'rating') {
                scrollToReviews();
            }
            getMainData();
        }
        // 卸载评论组件时（切换商品详情页时）清除商品详情页的评分
        return function() {
            return onInit === null || onInit === void 0 ? void 0 : onInit({
                rating: -1,
                total: -1
            });
        };
    }, [
        pid
    ]);
    (0,react.useEffect)(function() {
        if (false) {}
        var reviewCache = get2HoursLocalReviews(pHandle);
        // setReviewCacheList(reviewCache)
        var IdCacheList = reviewCache.map(function(i) {
            return i.id;
        });
        var excludeCacheIdReviews = reviewList.filter(function(i) {
            return !IdCacheList.includes(i.id);
        });
        var finalList = ProductsReviewsNew_toConsumableArray(reviewCache).concat(ProductsReviewsNew_toConsumableArray(excludeCacheIdReviews));
        var showLimitNum = 1;
        if (finalList.length > showLimitNum) {
            finalList = finalList.slice(0, showLimitNum);
        }
        setReviewList(finalList);
    // console.log(finalList)
    // setReviewList([])
    }, [
        formDrawerOpen,
        fetchCount
    ]);
    function getReviewList() {
        return _getReviewList.apply(this, arguments);
    }
    function _getReviewList() {
        _getReviewList = ProductsReviewsNew_asyncToGenerator(runtime_default().mark(function _callee(param3) {
            var scroll, param1, res, data, result, fig, reviewFitCalc, computedPercent, ref, smPer, lgPer, truePer, isShow;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        scroll = param3 === void 0 ? false : param3;
                        _ctx.prev = 1;
                        setIsLoading(true);
                        reviewList.length = 0;
                        param1 = (0,addQueryParam/* default */.Z)("".concat(BASE_URL, "/review"), 'handle', pHandle);
                        _ctx.next = 7;
                        return fetch("".concat(param1, "&limit=3&sortKey=MEDIA_FIRST"));
                    case 7:
                        res = _ctx.sent;
                        if (!(res.status === 200 && res.ok)) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 11;
                        return res.json();
                    case 11:
                        data = _ctx.sent;
                        result = cloneDeep_default()(data.body);
                        if (data.status === 200) {
                            setReviewCount(data.body.count);
                            setReviewAverage(data.body.average);
                            setReviewList(data.body.items);
                            fig = data.body.reviewFit;
                            reviewFitCalc = {
                            };
                            if (fig && fig.total > 0) {
                                computedPercent = function(total, arrs, param) {
                                    var fixed = param === void 0 ? 0 : param;
                                    return arrs.map(function(i) {
                                        return Number((i * 100 / total).toFixed(fixed));
                                    });
                                };
                                ref = ProductsReviewsNew_slicedToArray(computedPercent(fig.total, [
                                    fig.small,
                                    fig.large, 
                                ]), 2), smPer = ref[0], lgPer = ref[1];
                                truePer = 100 - smPer - lgPer;
                                isShow = fig.total >= 10 && Math.max(smPer, truePer, lgPer) >= 7 * 10;
                                reviewFitCalc = {
                                    smPer: smPer,
                                    truePer: truePer,
                                    lgPer: lgPer,
                                    show: isShow
                                };
                                setReviewFigure(ProductsReviewsNew_objectSpread({
                                }, fig, {
                                    smPer: smPer,
                                    truePer: truePer,
                                    lgPer: lgPer
                                }));
                                setShowPercentBox(true);
                            } else {
                                reviewFitCalc = {
                                    show: false
                                };
                                setShowPercentBox(false);
                            }
                            setFetchCount(fetchCount + 1);
                            setTimeout(function() {
                                window.parent.postMessage({
                                    // @ts-ignore
                                    reviewNewRect: document.querySelector('.reviews-wrapper').getBoundingClientRect()
                                }, '*');
                                window.parent.postMessage({
                                    value: Object.assign(result, {
                                        reviewFitCalc: reviewFitCalc
                                    }),
                                    reviewOnReday: true
                                }, '*');
                            });
                            onInit === null || onInit === void 0 ? void 0 : onInit({
                                rating: data.body.average.toFixed(1),
                                total: data.body.count
                            });
                        } else {
                            material_react_toastify_cjs_production_min.toast.error(data.message || 'Server error, please feed back through the customer service plug-in');
                        }
                    case 14:
                        _ctx.next = 20;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        console.log(_ctx.t0);
                        material_react_toastify_cjs_production_min.toast.dark('Oops, fetch data failed. Please check your network and try again.');
                    case 20:
                        setIsLoaded(true);
                        setIsLoading(false);
                        // const [mod, res] = await Promise.all([
                        //   import('cheerio'),
                        //   fetch(
                        //     ttParams(`${BASE_HTML_URL}/reviews/reviews_for_widget`, {
                        //       ...searchParams,
                        //       product_id: productId,
                        //     }) as string
                        //   ),
                        // ])
                        // setReviewData({ ...reviewData, total: totalNum * 5 })
                        // setReviewList(listArr)
                        // console.log('List data-->', listArr)
                        if (scroll) {
                            scrollToReviews();
                        }
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return _getReviewList.apply(this, arguments);
    }
    /*
  useEffect(() => {
    if (productId && !formDrawerOpen) {
      getReviewList()
    }
  }, [productId, formDrawerOpen])
  */ (0,react.useEffect)(function() {
        if (productId) {
            getReviewList();
        }
    }, [
        productId
    ]);
    (0,react.useEffect)(function() {
        if (productId && pData.spu && fetchCount) {
            var _spu, ref;
            reviewReportData = {
                product_from_page: (ref = localStorage.getItem("product_from_page-".concat((_spu = pData.spu) !== null && _spu !== void 0 ? _spu : ''))) !== null && ref !== void 0 ? ref : '',
                product_spu: pData.spu,
                product_name: pTitle,
                is_available: pData.available,
                web_original_price: +pData.compareAtPrice,
                web_current_price: +pData.price,
                web_discount_price: +(pData.compareAtPrice - pData.price).toFixed(2),
                review_number: reviewCount,
                average_overall_rating: +reviewAverage.toFixed(1),
                is_refactor: !isExtension
            };
        }
    }, [
        pData.spu,
        fetchCount
    ]);
    (0,react.useEffect)(function() {
        registerMessage();
    }, []);
    var ref13, ref14;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "reviews-wrapper relative min-h-full ".concat(pData.platform === 'pc' || upSm ? 'p-4 pb-0 border-1 border-gray-100' : "pt-4 ".concat(isExtension ? ' px-0 pb-0' : ' px-4 pb-0')),
        children: [
            fetchCount > 0 && !!pData.spu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                className: "absolute top-0 left-0 w-full",
                initialInView: false,
                triggerOnce: true,
                threshold: 1,
                onChange: function(e) {
                    if (e) {
                        var ref;
                        var reviewFrom = window.localStorage.getItem('review_from');
                        if (reviewFrom) {
                            window.localStorage.removeItem('review_from');
                        }
                        console.log('ReviewRegionShow', ProductsReviewsNew_objectSpread({
                        }, reviewReportData, {
                            check_review_method: +(reviewFrom || 3)
                        }));
                        window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('ReviewRegionShow', ProductsReviewsNew_objectSpread({
                        }, reviewReportData, {
                            check_review_method: +(reviewFrom || 3)
                        }));
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "block opacity-0 h-36 w-full bg-tag-yellow-light"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                className: "text-black flex justify-between items-center relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-sm font-semibold md:font-bold md:text-lg",
                        children: [
                            "Reviews",
                            reviewCount ? " (".concat(reviewCount > 999 ? '999+' : reviewCount, ")") : ''
                        ]
                    }),
                    isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-1 h-7 inline-flex items-center justify-center text-xs px-4 cursor-pointer border-tag-grayccc select-none",
                        onClick: function() {
                            var ref, ref17;
                            setTimeout(function() {
                                return setFormDrawerOpen(true);
                            }, 50);
                            window.parent.postMessage({
                                reviews: 'OpenFullScreen'
                            }, '*');
                            window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('WriteReviewButtonClick', reviewReportData);
                            console.log('WriteReviewButtonClick', reviewReportData);
                            window === null || window === void 0 ? void 0 : (ref17 = window.sensors) === null || ref17 === void 0 ? void 0 : ref17.track('WriteReviewPannelShow', reviewReportData);
                            console.log('WriteReviewPannelShow', reviewReportData);
                        },
                        children: "Write A Review"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex ".concat(reviewCount || reviewList.length ? 'justify-between' : 'justify-center py-7 mb-2', " items-center mt-4 bg-tag-grayf5 text-sm font-medium"),
                children: reviewCount || reviewList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingBox, {
                    reviewList: reviewList,
                    reviewFigure: reviewFigure,
                    reviewAverage: reviewAverage,
                    showPercentBox: showPercentBox,
                    preRight: "pl-7"
                }) : !fetchCount ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "animate-spin inline-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiOutlineLoading */.xz6, {
                        size: 24
                    })
                }) : 'No reviews yet'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewList, {
                figure: figure,
                reviewList: reviewList,
                previewLimit: 3,
                disableViewMore: true
            }),
            (reviewCount || 0) > 0 && !!pData.spu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_m/* InView */.df, {
                initialInView: false,
                triggerOnce: true,
                threshold: 1,
                onChange: function(e) {
                    if (e) {
                        var ref;
                        console.log('ViewAllReviewButtonShow', reviewReportData);
                        window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('ViewAllReviewButtonShow', reviewReportData);
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center py-3 text-gray-400 text-xs cursor-pointer",
                    onClick: function() {
                        var ref, ref18;
                        setTimeout(function() {
                            return setReviewListDrawer(true);
                        }, 50);
                        window.parent.postMessage({
                            reviews: 'OpenFullScreen'
                        }, '*');
                        window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('ViewAllReviewButtonClick', reviewReportData);
                        console.log('ViewAllReviewButtonClick', reviewReportData);
                        window === null || window === void 0 ? void 0 : (ref18 = window.sensors) === null || ref18 === void 0 ? void 0 : ref18.track('ReviewListShow', reviewReportData);
                        console.log('ReviewListShow', reviewReportData);
                    },
                    children: [
                        "View All",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineArrowForwardIos */.Djl, {
                            color: "inherit",
                            fontSize: "10",
                            className: "ml-1"
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDrawer, {
                drawerOpen: formDrawerOpen,
                onClose: function() {
                    var ref;
                    setFormDrawerOpen(false);
                    if (isExtension) {
                        disableUserEvent();
                        window.parent.postMessage({
                            reviews: 'CloseFullScreen'
                        }, '*');
                    }
                    window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('WriteReviewPannelClose', reviewReportData);
                    console.log('WriteReviewPannelClose', reviewReportData);
                },
                figure: figure,
                productId: productId,
                pTitle: pTitle,
                pCover: pData.pCover,
                pHandle: pHandle,
                reviewReportData: reviewReportData,
                platform: (ref13 = pData === null || pData === void 0 ? void 0 : pData.platform) !== null && ref13 !== void 0 ? ref13 : '',
                // todo: 需要通过路由查询来判断是否来源邮箱
                isEmail: (ref14 = pData === null || pData === void 0 ? void 0 : pData.isEmail) !== null && ref14 !== void 0 ? ref14 : false,
                isExtension: isExtension,
                loginEmail: pData.email || ''
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewListDrawer, {
                figure: figure,
                drawerOpen: reviewListDrawer,
                onClose: function(stayTime) {
                    var ref;
                    setReviewListDrawer(false);
                    if (isExtension) {
                        disableUserEvent();
                        window.parent.postMessage({
                            reviews: 'CloseFullScreen'
                        }, '*');
                    }
                    window === null || window === void 0 ? void 0 : (ref = window.sensors) === null || ref === void 0 ? void 0 : ref.track('ReviewListLeave', ProductsReviewsNew_objectSpread({
                    }, reviewReportData, {
                        stay_time: stayTime
                    }));
                    console.log('ReviewListLeave', ProductsReviewsNew_objectSpread({
                    }, reviewReportData, {
                        stay_time: stayTime
                    }));
                },
                // productId={productId}
                pHandle: pHandle,
                reviewReportData: reviewReportData,
                isExtension: isExtension
            })
        ]
    }));
};
/* harmony default export */ var ProductsReviewsNew = (ProductsReviews);


/***/ }),

/***/ 98078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ styleBtnBlack; },
/* harmony export */   "h": function() { return /* binding */ styleBtnWhite; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var styleBtnBlack = {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '9px 12px!important',
    border: '1px solid!important',
    borderRadius: '0!important',
    lineHeight: 1.5,
    backgroundColor: '#000000!important',
    borderColor: '#000000!important',
    color: '#ffffff!important',
    fontWeight: '600',
    '&:hover': {
        backgroundColor: '#333!important',
        borderColor: '#333!important',
        boxShadow: 'none!important'
    },
    '&.MuiLoadingButton-loading': {
        backgroundColor: 'rgb(127, 127, 127)!important',
        borderColor: 'rgb(127, 127, 127)!important',
        color: 'transparent!important',
        '.MuiLoadingButton-loadingIndicator': {
            color: 'white!important'
        }
    }
};
var styleBtnWhite = _objectSpread({
}, styleBtnBlack, {
    backgroundColor: '#ffffff!important',
    borderColor: '#000000!important',
    color: '#000000!important',
    '&:hover': {
        backgroundColor: '#eee!important',
        borderColor: '#666!important',
        boxShadow: 'none!important',
        color: '#666!important'
    }
});


/***/ }),

/***/ 58223:
/***/ (function(module) {


function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
!function(e, t) {
     true ? module.exports = t() : 0;
}(void 0, function() {
    "use strict";
    var e1 = function e1(e, t2) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t2 && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    };
    var t1 = function t1(t) {
        var _arguments = arguments, _loop = function(n) {
            var i = null != _arguments[n] ? _arguments[n] : {
            };
            n % 2 ? e1(Object(i), !0).forEach(function(e) {
                r1(t, e, i[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : e1(Object(i)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
            });
        };
        for(var n = 1; n < arguments.length; n++)_loop(n);
        return t;
    };
    var r1 = function r1(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    };
    var s = function s(e) {
        if (!e) return "";
        var t = 1024;
        return e < t ? e + "B" : e < Math.pow(t, 2) ? (e / t).toFixed(2) + "K" : e < Math.pow(t, 3) ? (e / Math.pow(t, 2)).toFixed(2) + "M" : e < Math.pow(t, 4) ? (e / Math.pow(t, 3)).toFixed(2) + "G" : (e / Math.pow(t, 4)).toFixed(2) + "T";
    };
    var l = function l() {
        return function() {
        };
    };
    var i1 = "undefined" != typeof globalThis ? globalThis :  true ? window : 0;
    var a1 = function(e, t) {
        return e(t = {
            exports: {
            }
        }, t.exports), t.exports;
    }(function(e2, t3) {
        (function() {
            var c = function c(e) {
                return !!e.exifdata;
            };
            var u = function u(e3, t4) {
                function n1(n2) {
                    var i4 = f(n2);
                    e3.exifdata = i4 || {
                    };
                    var a4 = function(e4) {
                        var t5 = new DataView(e4);
                        if (255 != t5.getUint8(0) || 216 != t5.getUint8(1)) return !1;
                        var n = 2, r = e4.byteLength, i = function i(e, t) {
                            return 56 === e.getUint8(t) && 66 === e.getUint8(t + 1) && 73 === e.getUint8(t + 2) && 77 === e.getUint8(t + 3) && 4 === e.getUint8(t + 4) && 4 === e.getUint8(t + 5);
                        };
                        for(; n < r;){
                            if (i(t5, n)) {
                                var a = t5.getUint8(n + 7);
                                return a % 2 != 0 && (a += 1), 0 === a && (a = 4), g(e4, n + 8 + a, t5.getUint16(n + 6 + a));
                            }
                            n++;
                        }
                    }(n2);
                    if (e3.iptcdata = a4 || {
                    }, r2.isXmpEnabled) {
                        var o3 = function(e) {
                            if (!("DOMParser" in self)) return;
                            var t = new DataView(e);
                            if (255 != t.getUint8(0) || 216 != t.getUint8(1)) return !1;
                            var n = 2, r = e.byteLength, i = new DOMParser;
                            for(; n < r - 4;){
                                if ("http" == m(t, n, 4)) {
                                    var a = n - 1, o = t.getUint16(n - 2) - 1, s = m(t, a, o), l = s.indexOf("xmpmeta>") + 8, c = (s = s.substring(s.indexOf("<x:xmpmeta"), l)).indexOf("x:xmpmeta") + 10;
                                    return s = s.slice(0, c) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:tiff="http://ns.adobe.com/tiff/1.0/" xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" xmlns:exif="http://ns.adobe.com/exif/1.0/" xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + s.slice(c), S(i.parseFromString(s, "text/xml"));
                                }
                                n++;
                            }
                        }(n2);
                        e3.xmpdata = o3 || {
                        };
                    }
                    t4 && t4.call(e3);
                }
                if (e3.src) if (/^data\:/i.test(e3.src)) n1(function(e, t) {
                    t = t || e.match(/^data\:([^\;]+)\;base64,/im)[1] || "", e = e.replace(/^data\:([^\;]+)\;base64,/gim, "");
                    for(var n = atob(e), r = n.length, i = new ArrayBuffer(r), a = new Uint8Array(i), o = 0; o < r; o++)a[o] = n.charCodeAt(o);
                    return i;
                }(e3.src));
                else if (/^blob\:/i.test(e3.src)) {
                    (a3 = new FileReader).onload = function(e) {
                        n1(e.target.result);
                    }, (function(e, t) {
                        var n = new XMLHttpRequest;
                        n.open("GET", e, !0), n.responseType = "blob", n.onload = function(e) {
                            200 != this.status && 0 !== this.status || t(this.response);
                        }, n.send();
                    })(e3.src, function(e) {
                        a3.readAsArrayBuffer(e);
                    });
                } else {
                    var i3 = new XMLHttpRequest;
                    i3.onload = function() {
                        if (200 != this.status && 0 !== this.status) throw "Could not load image";
                        n1(i3.response), i3 = null;
                    }, i3.open("GET", e3.src, !0), i3.responseType = "arraybuffer", i3.send(null);
                }
                else if (self.FileReader && (_instanceof(e3, self.Blob) || _instanceof(e3, self.File))) {
                    var a3;
                    (a3 = new FileReader).onload = function(e) {
                        n1(e.target.result);
                    }, a3.readAsArrayBuffer(e3);
                }
            };
            var f = function f(e) {
                var t = new DataView(e);
                if (255 != t.getUint8(0) || 216 != t.getUint8(1)) return !1;
                for(var n = 2, r = e.byteLength; n < r;){
                    if (255 != t.getUint8(n)) return !1;
                    if (225 == t.getUint8(n + 1)) return A(t, n + 4, t.getUint16(n + 2));
                    n += 2 + t.getUint16(n + 2);
                }
            };
            var g = function g(e, t, n) {
                for(var r, i, a, o, s = new DataView(e), l = {
                }, c = t; c < t + n;)28 === s.getUint8(c) && 2 === s.getUint8(c + 1) && (o = s.getUint8(c + 2)) in d1 && (a = s.getInt16(c + 3), i = d1[o], r = m(s, c + 5, a), l.hasOwnProperty(i) ? _instanceof(l[i], Array) ? l[i].push(r) : l[i] = [
                    l[i],
                    r
                ] : l[i] = r), c++;
                return l;
            };
            var h = function h(e, t, n, r, i) {
                var a, o, s = e.getUint16(n, !i), l = {
                };
                for(o = 0; o < s; o++)a = n + 12 * o + 2, l[r[e.getUint16(a, !i)]] = p(e, a, t, n, i);
                return l;
            };
            var p = function p(e, t, n, r, i) {
                var a, o, s, l, c, u, f = e.getUint16(t + 2, !i), d = e.getUint32(t + 4, !i), g = e.getUint32(t + 8, !i) + n;
                switch(f){
                    case 1:
                    case 7:
                        if (1 == d) return e.getUint8(t + 8, !i);
                        for(a = d > 4 ? g : t + 8, o = [], l = 0; l < d; l++)o[l] = e.getUint8(a + l);
                        return o;
                    case 2:
                        return m(e, a = d > 4 ? g : t + 8, d - 1);
                    case 3:
                        if (1 == d) return e.getUint16(t + 8, !i);
                        for(a = d > 2 ? g : t + 8, o = [], l = 0; l < d; l++)o[l] = e.getUint16(a + 2 * l, !i);
                        return o;
                    case 4:
                        if (1 == d) return e.getUint32(t + 8, !i);
                        for(o = [], l = 0; l < d; l++)o[l] = e.getUint32(g + 4 * l, !i);
                        return o;
                    case 5:
                        if (1 == d) return c = e.getUint32(g, !i), u = e.getUint32(g + 4, !i), (s = new Number(c / u)).numerator = c, s.denominator = u, s;
                        for(o = [], l = 0; l < d; l++)c = e.getUint32(g + 8 * l, !i), u = e.getUint32(g + 4 + 8 * l, !i), o[l] = new Number(c / u), o[l].numerator = c, o[l].denominator = u;
                        return o;
                    case 9:
                        if (1 == d) return e.getInt32(t + 8, !i);
                        for(o = [], l = 0; l < d; l++)o[l] = e.getInt32(g + 4 * l, !i);
                        return o;
                    case 10:
                        if (1 == d) return e.getInt32(g, !i) / e.getInt32(g + 4, !i);
                        for(o = [], l = 0; l < d; l++)o[l] = e.getInt32(g + 8 * l, !i) / e.getInt32(g + 4 + 8 * l, !i);
                        return o;
                }
            };
            var m = function m(e, t, r) {
                var i = "";
                for(n = t; n < t + r; n++)i += String.fromCharCode(e.getUint8(n));
                return i;
            };
            var A = function A(e5, t6) {
                if ("Exif" != m(e5, t6, 4)) return !1;
                var n3, r3, c, u, f, d = t6 + 6;
                if (18761 == e5.getUint16(d)) n3 = !1;
                else {
                    if (19789 != e5.getUint16(d)) return !1;
                    n3 = !0;
                }
                if (42 != e5.getUint16(d + 2, !n3)) return !1;
                var g = e5.getUint32(d + 4, !n3);
                if (g < 8) return !1;
                if ((r3 = h(e5, d, d + g, a2, n3)).ExifIFDPointer) for(c in u = h(e5, d, d + r3.ExifIFDPointer, i2, n3)){
                    switch(c){
                        case "LightSource":
                        case "Flash":
                        case "MeteringMode":
                        case "ExposureProgram":
                        case "SensingMethod":
                        case "SceneCaptureType":
                        case "SceneType":
                        case "CustomRendered":
                        case "WhiteBalance":
                        case "GainControl":
                        case "Contrast":
                        case "Saturation":
                        case "Sharpness":
                        case "SubjectDistanceRange":
                        case "FileSource":
                            u[c] = l1[c][u[c]];
                            break;
                        case "ExifVersion":
                        case "FlashpixVersion":
                            u[c] = String.fromCharCode(u[c][0], u[c][1], u[c][2], u[c][3]);
                            break;
                        case "ComponentsConfiguration":
                            u[c] = l1.Components[u[c][0]] + l1.Components[u[c][1]] + l1.Components[u[c][2]] + l1.Components[u[c][3]];
                    }
                    r3[c] = u[c];
                }
                if (r3.GPSInfoIFDPointer) for(c in f = h(e5, d, d + r3.GPSInfoIFDPointer, o2, n3)){
                    if ("GPSVersionID" === c) f[c] = f[c][0] + "." + f[c][1] + "." + f[c][2] + "." + f[c][3];
                    r3[c] = f[c];
                }
                return r3.thumbnail = (function(e6, t7, n4, r4) {
                    var i = function(e, t, n) {
                        var r = e.getUint16(t, !n);
                        return e.getUint32(t + 2 + 12 * r, !n);
                    }(e6, t7 + n4, r4);
                    if (!i) return {
                    };
                    if (i > e6.byteLength) return {
                    };
                    var a = h(e6, t7, t7 + i, s1, r4);
                    if (a.Compression) switch(a.Compression){
                        case 6:
                            if (a.JpegIFOffset && a.JpegIFByteCount) {
                                var o = t7 + a.JpegIFOffset, l = a.JpegIFByteCount;
                                a.blob = new Blob([
                                    new Uint8Array(e6.buffer, o, l)
                                ], {
                                    type: "image/jpeg"
                                });
                            }
                            break;
                        case 1:
                            console.log("Thumbnail image format is TIFF, which is not implemented.");
                            break;
                        default:
                            console.log("Unknown thumbnail image format '%s'", a.Compression);
                    }
                    else 2 == a.PhotometricInterpretation && console.log("Thumbnail image format is RGB, which is not implemented.");
                    return a;
                })(e5, d, g, n3), r3;
            };
            var S = function S(e) {
                try {
                    var t = {
                    };
                    if (e.children.length > 0) for(var n = 0; n < e.children.length; n++){
                        var r = e.children.item(n), i = r.attributes;
                        for(var a in i){
                            var o = i[a], s = o.nodeName, l = o.nodeValue;
                            void 0 !== s && (t[s] = l);
                        }
                        var c = r.nodeName;
                        if (void 0 === t[c]) t[c] = w(r);
                        else {
                            if (void 0 === t[c].push) {
                                var u = t[c];
                                t[c] = [], t[c].push(u);
                            }
                            t[c].push(w(r));
                        }
                    }
                    else t = e.textContent;
                    return t;
                } catch (e7) {
                    console.log(e7.message);
                }
            };
            var r2 = function(e) {
                return _instanceof(e, r2) ? e : _instanceof(this, r2) ? void (this.EXIFwrapped = e) : new r2(e);
            };
            e2.exports && (t3 = e2.exports = r2), t3.EXIF = r2;
            var i2 = r2.Tags = {
                36864: "ExifVersion",
                40960: "FlashpixVersion",
                40961: "ColorSpace",
                40962: "PixelXDimension",
                40963: "PixelYDimension",
                37121: "ComponentsConfiguration",
                37122: "CompressedBitsPerPixel",
                37500: "MakerNote",
                37510: "UserComment",
                40964: "RelatedSoundFile",
                36867: "DateTimeOriginal",
                36868: "DateTimeDigitized",
                37520: "SubsecTime",
                37521: "SubsecTimeOriginal",
                37522: "SubsecTimeDigitized",
                33434: "ExposureTime",
                33437: "FNumber",
                34850: "ExposureProgram",
                34852: "SpectralSensitivity",
                34855: "ISOSpeedRatings",
                34856: "OECF",
                37377: "ShutterSpeedValue",
                37378: "ApertureValue",
                37379: "BrightnessValue",
                37380: "ExposureBias",
                37381: "MaxApertureValue",
                37382: "SubjectDistance",
                37383: "MeteringMode",
                37384: "LightSource",
                37385: "Flash",
                37396: "SubjectArea",
                37386: "FocalLength",
                41483: "FlashEnergy",
                41484: "SpatialFrequencyResponse",
                41486: "FocalPlaneXResolution",
                41487: "FocalPlaneYResolution",
                41488: "FocalPlaneResolutionUnit",
                41492: "SubjectLocation",
                41493: "ExposureIndex",
                41495: "SensingMethod",
                41728: "FileSource",
                41729: "SceneType",
                41730: "CFAPattern",
                41985: "CustomRendered",
                41986: "ExposureMode",
                41987: "WhiteBalance",
                41988: "DigitalZoomRation",
                41989: "FocalLengthIn35mmFilm",
                41990: "SceneCaptureType",
                41991: "GainControl",
                41992: "Contrast",
                41993: "Saturation",
                41994: "Sharpness",
                41995: "DeviceSettingDescription",
                41996: "SubjectDistanceRange",
                40965: "InteroperabilityIFDPointer",
                42016: "ImageUniqueID"
            }, a2 = r2.TiffTags = {
                256: "ImageWidth",
                257: "ImageHeight",
                34665: "ExifIFDPointer",
                34853: "GPSInfoIFDPointer",
                40965: "InteroperabilityIFDPointer",
                258: "BitsPerSample",
                259: "Compression",
                262: "PhotometricInterpretation",
                274: "Orientation",
                277: "SamplesPerPixel",
                284: "PlanarConfiguration",
                530: "YCbCrSubSampling",
                531: "YCbCrPositioning",
                282: "XResolution",
                283: "YResolution",
                296: "ResolutionUnit",
                273: "StripOffsets",
                278: "RowsPerStrip",
                279: "StripByteCounts",
                513: "JPEGInterchangeFormat",
                514: "JPEGInterchangeFormatLength",
                301: "TransferFunction",
                318: "WhitePoint",
                319: "PrimaryChromaticities",
                529: "YCbCrCoefficients",
                532: "ReferenceBlackWhite",
                306: "DateTime",
                270: "ImageDescription",
                271: "Make",
                272: "Model",
                305: "Software",
                315: "Artist",
                33432: "Copyright"
            }, o2 = r2.GPSTags = {
                0: "GPSVersionID",
                1: "GPSLatitudeRef",
                2: "GPSLatitude",
                3: "GPSLongitudeRef",
                4: "GPSLongitude",
                5: "GPSAltitudeRef",
                6: "GPSAltitude",
                7: "GPSTimeStamp",
                8: "GPSSatellites",
                9: "GPSStatus",
                10: "GPSMeasureMode",
                11: "GPSDOP",
                12: "GPSSpeedRef",
                13: "GPSSpeed",
                14: "GPSTrackRef",
                15: "GPSTrack",
                16: "GPSImgDirectionRef",
                17: "GPSImgDirection",
                18: "GPSMapDatum",
                19: "GPSDestLatitudeRef",
                20: "GPSDestLatitude",
                21: "GPSDestLongitudeRef",
                22: "GPSDestLongitude",
                23: "GPSDestBearingRef",
                24: "GPSDestBearing",
                25: "GPSDestDistanceRef",
                26: "GPSDestDistance",
                27: "GPSProcessingMethod",
                28: "GPSAreaInformation",
                29: "GPSDateStamp",
                30: "GPSDifferential"
            }, s1 = r2.IFD1Tags = {
                256: "ImageWidth",
                257: "ImageHeight",
                258: "BitsPerSample",
                259: "Compression",
                262: "PhotometricInterpretation",
                273: "StripOffsets",
                274: "Orientation",
                277: "SamplesPerPixel",
                278: "RowsPerStrip",
                279: "StripByteCounts",
                282: "XResolution",
                283: "YResolution",
                284: "PlanarConfiguration",
                296: "ResolutionUnit",
                513: "JpegIFOffset",
                514: "JpegIFByteCount",
                529: "YCbCrCoefficients",
                530: "YCbCrSubSampling",
                531: "YCbCrPositioning",
                532: "ReferenceBlackWhite"
            }, l1 = r2.StringValues = {
                ExposureProgram: {
                    0: "Not defined",
                    1: "Manual",
                    2: "Normal program",
                    3: "Aperture priority",
                    4: "Shutter priority",
                    5: "Creative program",
                    6: "Action program",
                    7: "Portrait mode",
                    8: "Landscape mode"
                },
                MeteringMode: {
                    0: "Unknown",
                    1: "Average",
                    2: "CenterWeightedAverage",
                    3: "Spot",
                    4: "MultiSpot",
                    5: "Pattern",
                    6: "Partial",
                    255: "Other"
                },
                LightSource: {
                    0: "Unknown",
                    1: "Daylight",
                    2: "Fluorescent",
                    3: "Tungsten (incandescent light)",
                    4: "Flash",
                    9: "Fine weather",
                    10: "Cloudy weather",
                    11: "Shade",
                    12: "Daylight fluorescent (D 5700 - 7100K)",
                    13: "Day white fluorescent (N 4600 - 5400K)",
                    14: "Cool white fluorescent (W 3900 - 4500K)",
                    15: "White fluorescent (WW 3200 - 3700K)",
                    17: "Standard light A",
                    18: "Standard light B",
                    19: "Standard light C",
                    20: "D55",
                    21: "D65",
                    22: "D75",
                    23: "D50",
                    24: "ISO studio tungsten",
                    255: "Other"
                },
                Flash: {
                    0: "Flash did not fire",
                    1: "Flash fired",
                    5: "Strobe return light not detected",
                    7: "Strobe return light detected",
                    9: "Flash fired, compulsory flash mode",
                    13: "Flash fired, compulsory flash mode, return light not detected",
                    15: "Flash fired, compulsory flash mode, return light detected",
                    16: "Flash did not fire, compulsory flash mode",
                    24: "Flash did not fire, auto mode",
                    25: "Flash fired, auto mode",
                    29: "Flash fired, auto mode, return light not detected",
                    31: "Flash fired, auto mode, return light detected",
                    32: "No flash function",
                    65: "Flash fired, red-eye reduction mode",
                    69: "Flash fired, red-eye reduction mode, return light not detected",
                    71: "Flash fired, red-eye reduction mode, return light detected",
                    73: "Flash fired, compulsory flash mode, red-eye reduction mode",
                    77: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
                    79: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
                    89: "Flash fired, auto mode, red-eye reduction mode",
                    93: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
                    95: "Flash fired, auto mode, return light detected, red-eye reduction mode"
                },
                SensingMethod: {
                    1: "Not defined",
                    2: "One-chip color area sensor",
                    3: "Two-chip color area sensor",
                    4: "Three-chip color area sensor",
                    5: "Color sequential area sensor",
                    7: "Trilinear sensor",
                    8: "Color sequential linear sensor"
                },
                SceneCaptureType: {
                    0: "Standard",
                    1: "Landscape",
                    2: "Portrait",
                    3: "Night scene"
                },
                SceneType: {
                    1: "Directly photographed"
                },
                CustomRendered: {
                    0: "Normal process",
                    1: "Custom process"
                },
                WhiteBalance: {
                    0: "Auto white balance",
                    1: "Manual white balance"
                },
                GainControl: {
                    0: "None",
                    1: "Low gain up",
                    2: "High gain up",
                    3: "Low gain down",
                    4: "High gain down"
                },
                Contrast: {
                    0: "Normal",
                    1: "Soft",
                    2: "Hard"
                },
                Saturation: {
                    0: "Normal",
                    1: "Low saturation",
                    2: "High saturation"
                },
                Sharpness: {
                    0: "Normal",
                    1: "Soft",
                    2: "Hard"
                },
                SubjectDistanceRange: {
                    0: "Unknown",
                    1: "Macro",
                    2: "Close view",
                    3: "Distant view"
                },
                FileSource: {
                    3: "DSC"
                },
                Components: {
                    0: "",
                    1: "Y",
                    2: "Cb",
                    3: "Cr",
                    4: "R",
                    5: "G",
                    6: "B"
                }
            };
            var d1 = {
                120: "caption",
                110: "credit",
                25: "keywords",
                55: "dateCreated",
                80: "byline",
                85: "bylineTitle",
                122: "captionWriter",
                105: "headline",
                116: "copyright",
                15: "category"
            };
            function w(e) {
                var t = {
                };
                if (1 == e.nodeType) {
                    if (e.attributes.length > 0) {
                        t["@attributes"] = {
                        };
                        for(var n = 0; n < e.attributes.length; n++){
                            var r = e.attributes.item(n);
                            t["@attributes"][r.nodeName] = r.nodeValue;
                        }
                    }
                } else if (3 == e.nodeType) return e.nodeValue;
                if (e.hasChildNodes()) for(var i = 0; i < e.childNodes.length; i++){
                    var a = e.childNodes.item(i), o = a.nodeName;
                    if (null == t[o]) t[o] = w(a);
                    else {
                        if (null == t[o].push) {
                            var s = t[o];
                            t[o] = [], t[o].push(s);
                        }
                        t[o].push(w(a));
                    }
                }
                return t;
            }
            r2.enableXmp = function() {
                r2.isXmpEnabled = !0;
            }, r2.disableXmp = function() {
                r2.isXmpEnabled = !1;
            }, r2.getData = function(e, t) {
                return !((self.Image && _instanceof(e, self.Image) || self.HTMLImageElement && _instanceof(e, self.HTMLImageElement)) && !e.complete) && (c(e) ? t && t.call(e) : u(e, t), !0);
            }, r2.getTag = function(e, t) {
                if (c(e)) return e.exifdata[t];
            }, r2.getIptcTag = function(e, t) {
                if (c(e)) return e.iptcdata[t];
            }, r2.getAllTags = function(e) {
                if (!c(e)) return {
                };
                var t, n = e.exifdata, r = {
                };
                for(t in n)n.hasOwnProperty(t) && (r[t] = n[t]);
                return r;
            }, r2.getAllIptcTags = function(e) {
                if (!c(e)) return {
                };
                var t, n = e.iptcdata, r = {
                };
                for(t in n)n.hasOwnProperty(t) && (r[t] = n[t]);
                return r;
            }, r2.pretty = function(e) {
                if (!c(e)) return "";
                var t, n = e.exifdata, r = "";
                for(t in n)n.hasOwnProperty(t) && ("object" == typeof n[t] ? _instanceof(n[t], Number) ? r += t + " : " + n[t] + " [" + n[t].numerator + "/" + n[t].denominator + "]\r\n" : r += t + " : [" + n[t].length + " values]\r\n" : r += t + " : " + n[t] + "\r\n");
                return r;
            }, r2.readFromBinaryFile = function(e) {
                return f(e);
            };
        }).call(i1);
    });
    a1.EXIF;
    var o1 = function o1(e, n) {
        this.defaultConfig = {
            quality: 0.7,
            useOriginal: !1,
            width: 1200,
            height: 800,
            success: l,
            fail: l
        }, this.config = t1(t1({
        }, this.defaultConfig), n), this.file = e, this.ctx = null, this.resize = null, this.core(e);
    };
    return o1.prototype.validate = function(e) {
        if (!document.createElement("canvas").getContext) throw new Error("Your browser does not support canvas");
        if (!e) throw new Error("No image input");
        if (!/image\/jpeg|image\/jpg|image\/png/.test(e.type)) throw new Error("Error in type, Support types are: jpeg, jpg, png");
    }, o1.prototype.core = function(e8) {
        try {
            this.validate(e8);
            var t8 = {
            };
            t8.originalSize = s(e8.size);
            var n5 = "";
            a1.getData(e8, function() {
                a1.getAllTags(this), n5 = a1.getTag(this, "Orientation");
            });
            var r5 = this, i5 = new FileReader;
            i5.onload = function(i6) {
                var a5 = new Image;
                a5.src = i6.target.result, a5.onerror = function() {
                    r5.config.fail("Image loading failed");
                }, a5.onload = function() {
                    var i7 = this.naturalWidth, a6 = this.naturalHeight;
                    t8.originalReSize = {
                        width: i7,
                        height: a6
                    }, r5.getResize(i7, a6);
                    var o4 = r5.resize, l = o4.compressedWidth, c = o4.compressedHeight;
                    console.log(r5), t8.resize = {
                        width: l,
                        height: c
                    };
                    var u = document.createElement("canvas"), f = u.getContext("2d");
                    this.ctx = f, u.width = l, u.height = c, f.fillStyle = "#fff", f.fillRect(0, 0, u.width, u.height), f.drawImage(this, 0, 0, l, c), r5.getBase64(n5, u).then(function(n6) {
                        t8.size = s(n6.length), t8.base64 = n6, t8.file = (function(e, t) {
                            var n = e.split(","), r = n[0].match(/:(.*?);/)[1], i = atob(n[1]), a = i.length, o = new Uint8Array(a);
                            for(; a--;)o[a] = i.charCodeAt(a);
                            return new File([
                                o
                            ], t, {
                                type: r
                            });
                        })(n6, e8.name), t8.originFile = e8, t8.blob = (function(e) {
                            for(var t = atob(e.split(",")[1]), n = [], r = 0; r < t.length; r++)n.push(t.charCodeAt(r));
                            return new Blob([
                                new Uint8Array(n)
                            ], {
                                type: "image/jpeg"
                            });
                        })(n6), t8.blobUrl = URL.createObjectURL(t8.blob), r5.config.success(t8);
                    });
                };
            }, i5.readAsDataURL(e8);
        } catch (e) {
            this.config.fail(e);
        }
    }, o1.prototype.getBase64 = function(e9, t9) {
        var n = this, r = null, i = this;
        return new Promise(function(a, o5) {
            try {
                (l = "data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/xABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAAAAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==", new Promise(function(e) {
                    if (void 0 === s) {
                        var t = new Image;
                        t.onload = function() {
                            s = 1 === t.width && 2 === t.height, e(s);
                        }, t.src = l;
                    } else e(s);
                })).then(function(o) {
                    navigator.userAgent.match(!o) ? (n.rotate(n, e9), r = t9.toDataURL("image/jpeg", i.config.quality)) : r = t9.toDataURL("image/jpeg", i.config.quality), a(r);
                });
            } catch (e) {
                o5(e);
            }
            var s, l;
        });
    }, o1.prototype.rotate = function(e, t) {
        var n = this.ctx, r = this.resize;
        switch(t){
            case 3:
                n.rotate(180 * Math.PI / 180), n.drawImage(e, -r.width, -r.height, r.width, r.height);
                break;
            case 6:
                n.rotate(90 * Math.PI / 180), n.drawImage(e, 0, -r.width, r.height, r.width);
                break;
            case 8:
                n.rotate(270 * Math.PI / 180), n.drawImage(e, -r.height, 0, r.height, r.width);
                break;
            case 2:
                n.translate(r.width, 0), n.scale(-1, 1), n.drawImage(e, 0, 0, r.width, r.height);
                break;
            case 4:
                n.translate(r.width, 0), n.scale(-1, 1), n.rotate(180 * Math.PI / 180), n.drawImage(e, -r.width, -r.height, r.width, r.height);
                break;
            case 5:
                n.translate(r.width, 0), n.scale(-1, 1), n.rotate(90 * Math.PI / 180), n.drawImage(e, 0, -r.width, r.height, r.width);
                break;
            case 7:
                n.translate(r.width, 0), n.scale(-1, 1), n.rotate(270 * Math.PI / 180), n.drawImage(e, -r.height, 0, r.height, r.width);
                break;
            default:
                n.drawImage(e, 0, 0, r.width, r.height);
        }
    }, o1.prototype.getResize = function(e10, t10) {
        var n7 = this.config, r6 = n7.width, i8 = n7.height;
        if (n7.useOriginal) this.resize = {
            compressedWidth: e10,
            compressedHeight: t10
        };
        else {
            this.resize = (function(e, t, n, r) {
                var i = e < t;
                if (i) {
                    var a = [
                        t,
                        e
                    ];
                    e = a[0], t = a[1];
                }
                var o = e, s = t;
                if (n < r) {
                    var l = [
                        r,
                        n
                    ];
                    n = l[0], r = l[1];
                }
                return e > n && (s = (o = n) * t / e), {
                    compressedWidth: i ? s : o,
                    compressedHeight: i ? o : s
                };
            })(e10, t10, r6, i8);
        }
    }, o1;
}); //# sourceMappingURL=compress.min.js.map


/***/ })

}]);